<template>
  <div class="page-wrapper">
    <div class="flex-wrapper">
      <div class="cat-container">
        <div class="col-12 h-100 scroll-container category-container">




          <button class="btn btn-primary" v-on:click="downloadProductListExcel"><i class="fas fa-download"></i> Export</button>
          <input type="file" ref="file" style="display: none;" v-on:change="excelFilePickedUp"/>
          <button class="btn btn-warning" v-on:click="onFileSelectorClick"><i class="fas fa-file-excel"></i> <i class="fas fa-upload"></i> Import</button>


          <ul class="list-group" style="margin-top: 10px;">
            <draggable v-model="categories" :options="{disabled: categoryOrderable == false, animation:300}" :group="categories" @start="drag=true" @end="drag=false" @change="onCategoryReordered">
              <div v-for="(cat, index) in categories"  v-bind:id="'cat-parent-' + cat.id" >
<!--                <li class="list-group-item  text-left"  data-toggle="collapse" :data-target="'#cat-group-' + cat.id" aria-expanded="false">-->
                <li class="list-group-item  text-left"  v-on:click="openCategoryItems(cat)" v-bind:class="{'category-selected':currentCatItem !== false && currentCatItem.id === cat.id}">
                  <span class="side-menu-text font-weight-bold">[{{cat.code}}] {{cat.title}}</span>

<!--                  <span class="collapse-button float-right rotate-if-collapsed"  :id="'category-toggle-'+cat.id"/>-->
                  <span v-if="user !== false && user.manageProduct === true"><i class="fa fa-edit float-right" v-on:click.stop="showCategoryEdit(cat)"></i></span>
                  <div class="selected-arrow"></div>
                </li>
<!--                <div v-bind:id="'cat-group-' + cat.id" class="collapse" :aria-labelledby="'cat-parent-' + cat.id">-->
<!--                  <draggable v-model="cat.list" :group="categories" @start="drag=true" @end="drag=false" @change="onSubCategoryReordered(index)">-->
<!--                    <li v-for="(subCat, sindex) in cat.list" class="list-group-item sub-category text-left" v-on:click="openCategoryItems(subCat)" v-bind:class="{'category-selected': currentCatItem.id == subCat.id}">-->
<!--                      <span class="side-menu-text" style="padding-left:20px;">{{subCat.title}}</span>-->
<!--                      <span><i class="fa fa-edit float-right" v-on:click.stop="showCategoryEdit(subCat)"></i></span>-->
<!--                    </li>-->
<!--                  </draggable>-->
<!--                  <li class="list-group-item">-->
<!--                    <span v-on:click="showSubCategoryEdit(cat)"><i class="fas fa-plus"></i> Add Category</span>-->
<!--                  </li>-->
<!--                </div>-->

              </div>
            </draggable>
            <li class="list-group-item text-left" v-on:click="showCategoryEdit()"><i class="fas fa-plus"></i> Add Category</li>

          </ul>

          <div class="kh-btn kh-9" style="margin-top: 30px;" @click="getLowStockProducts">LOW STOCK PRODUCTS</div>

          <div class="kh-btn kh-7" style="margin-top: 30px; color: black;" @click="getNoMarginTaggedProducts">NO MARGIN PRODUCTS</div>


          <div class="kh-btn kh-btn-smaller kh-11" style="margin-top: 30px;" @click="getEndingStockProducts(7)">Finish within 7 days</div>
          <div class="kh-btn kh-btn-smaller kh-11" style="margin-top: 5px;" @click="getEndingStockProducts(14)">Finish within 14 days</div>
          <div style="background: white; padding: 10px; margin-top: 3px;">
            Stock ending date of all products calculated at 3AM everyday.
          </div>

          <button class="btn btn-primary" v-on:click="downloadChildProductListExcel"><i class="fas fa-download"></i> Download Child Products</button>
        </div>
      </div>
      <div class="product-list-container">
        <div class="col-12  h-100" >

          <div class="container-fluid h-100">
            <div class="row h-100">
              <div class="h-100 " v-bind:class="{'col-12': orderItem == false, 'col-6': orderItem != false}" style="position: relative; padding-left:0; padding-right:0;">
                <div class="container-fluid" style="background-color: white; height:100px;position: sticky;top:0;">
                  <div class="row">
                    <div class="col-8 text-left border-btn-container">
                      <div class="border-btn" v-if="currentHighCatItem !== false">{{currentHighCatItem.title}}</div>
                      <div class="border-btn" v-if="currentCatItem !== false">{{currentCatItem.title}} </div>
                      <div class="border-btn kh-6" v-if="products.length > 0" @click="getCurrentProductStockStatus">Stock Report</div>
<!--                      <div class="border-btn" v-if="currentCatItem !== false" @click="downloadCategoryStockReport(currentCatItem)">Full Stock Report</div>-->
<!--                      <button class="btn btn-warning" v-on:click="downloadProductsMigrationStockReport(currentCatItem)"><i class="fas fa-file-excel"></i> <i class="fas fa-upload"></i> Test Correction</button>-->
                    </div>
                    <div class="col-4 text-right border-btn-container">

                      <div class="border-btn" v-if="orderMode == false" v-on:click="toggleOrderMode"><i class="fas fa-shopping-cart"></i> Order</div>
                      <div class="border-btn" v-if="user !== false && user.manageProduct === true && currentCatItem != false" v-on:click="showProductEdit()"><i class="fa fa-plus"></i> Add</div>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" style="width: 100%; display: flex;">
                      <select class="border-btn" v-model="searchType" @change="onSearchTypeChanged">
                        <option v-for="t in searchTypes" :value="t">{{t.toUpperCase()}}</option>
                      </select>
                      <select class="border-btn" v-model="orderType" @change="onSearchTypeChanged">
                        <option v-for="t in orderTypes" :value="t">{{t.toUpperCase()}}</option>
                      </select>
                      <input type="text" v-model="searchWord" v-on:keyup="search" style="width: calc(100% - 50px)" placeholder="Search Product"/>
                      <span style="height: 30px; line-height: 30px; padding-left:10px;" v-on:click="initialiseSearch"><i class="fas fa-times"></i></span>
                    </div>
                  </div>
                </div>
                <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto; overflow-x: auto;">


                <table class="table" v-if="currentCatItem != false">
                  <thead>
                  <tr class="stick-top-0-row">
                    <th style="display:none;">Ref</th>
                    <th class="text-left">Code</th>
                    <th class="text-left" style="cursor: pointer; text-decoration: underline;" @click="sortItemsBy('title')">Title</th>
                    <th></th>
                    <th class="text-left">Vendor</th>
                    <th class="text-left">Unit</th>
                    <th v-if="user.viewProductCost === true">Prime Cost</th>
                    <th v-if="user.viewProductCost === true" @click="sortItemsBy('marginRate')" style="cursor: pointer; text-decoration: underline;">Margin</th>
                    <th v-if="user.viewProductCost === true">Sale Price</th>
                    <th v-if="user.viewProductCost === true">No Margin Tag</th>
                    <th>VAT</th>
                    <th @click="sortItemsBy('currentStock')" style="cursor: pointer; text-decoration: underline;">Stock</th>
                    <th @click="sortItemsBy('expectedEndDate')" style="cursor: pointer; text-decoration: underline;">Ending</th>
                    <th @click="sortItemsBy('inventoryExpiryDate')" style="cursor: pointer; text-decoration: underline;">BBD</th>
<!--                    <th></th>-->
                    <th>Order to Supplier</th>
                    <th>Last Stock In</th>
                    <th>Weight</th>
                    <th  @click="sortItemsBy('available')" style="cursor: pointer; text-decoration: underline;">Availability
<!--                      <br/><span><i class="fas fa-check"></i> Show</span>-->
<!--                      <br/><span><i class="fas fa-times"></i> N/A</span>-->
                    </th>
                    <th @click="sortItemsBy('canOrderKokoro')" style="cursor: pointer; text-decoration: underline;">Kokoro order</th>
                    <th>Vendor order</th>
                    <th>Unit Value</th>
                    <th>Value</th>
<!--                    <th></th>-->
<!--                    <th></th>-->


                  </tr>
                  </thead>
                  <draggable v-model="products" :options="{disabled: productOrderable == false, animation:300}"  :group="products" @start="drag=true" @end="drag=false" @change="onProductReordered" tag="tbody">
                    <tr class="hover-item" v-for="(item, index) in products" :key="item.id" v-bind:class="{ 'category-selected': editProductItem != false && editProductItem.id == item.id , 'deleted-item': item.deleted === true}" >
                      <td style="display:none;">#{{item.id}}</td>


<!--                      <td>-->
<!--                        <img :src="getFirstImage(item)" width="50px">-->

<!--                      </td>-->
                      <td class="text-left">{{item.code}}</td>
                      <td class="text-left" v-on:click="openProductItem(item)" style="text-decoration: underline;">{{item.title}}<span v-if="item.deleted === true">&nbsp;&nbsp; <strong>DELETED</strong></span></td>
                      <td>
                        <div v-if="item.parentId === 0" @click.stop="openProductDataView(item)">
                          <span style="font-size: 1.3rem;"><i class="fas fa-chart-line"></i></span>
                        </div>
                      </td>
                      <td class="text-left">
                        <div v-if="item.vendors.length > 0"></div>
                        <span v-for="(v, i) in item.vendors"><span v-if="i>0">,</span>{{v.title}}</span>
                      </td>
                      <td class="text-left">{{item.unit}}</td>
                      <td v-if="user.viewProductCost === true">
                        <span v-if="item.inventoryUnitPriceFloat > 0">{{item.inventoryUnitPriceFloat.toFixed(2)}}</span>
                        <span class="attention-required" v-else>{{item.sourcePriceFloat}}</span>
                        <span v-if="item.inventoryUnitPriceSet === false"><i class="fas fa-exclamation-circle"></i></span>
                      </td>
                      <td v-if="user.viewProductCost === true">
                        <span v-if="item.inventoryMarginFloat > 0">{{(item.inventoryMarginFloat).toFixed(2)}}%</span>
                        <span v-else>{{(item.marginRate/100.0).toFixed(2)}}%</span>
<!--                        <span v-else-if="item.marginAmount > 0">£{{(item.marginAmount/100.0).toFixed(2)}}</span>-->
                      </td>
                      <td v-if="user.viewProductCost === true">
                        <span v-if="item.inventoryPriceFloat > 0">{{item.inventoryPriceFloat.toFixed(2)}}</span>
                        <span class="attention-required" v-else>{{(item.price/100.0).toFixed(2)}}</span>
                        <span v-if="item.inventoryPriceSet === false"><i class="fas fa-exclamation-circle"></i></span>
                      </td>
                      <td>
                        <div v-if="item.noMarginTags !== null && item.noMarginTags.length > 0" class="attention-required">
                          <span v-for="tag in item.noMarginTags" :key="'product-' + item.id +'-nm-tag-'+tag">{{tag}}</span>
                        </div>
                      </td>
                      <td>{{(item.taxRate/100).toFixed(2)}}%</td>
                      <td>

                        <div v-if="item.parentId == 0" v-on:click.stop="openStockView(item.id)" class="hover-border">
                          <span v-if="item.useVariablePrice === true">
                          {{(item.currentStockWeight/100.0).toFixed(2)}}Kg
                          </span>
                          <span v-else>
                          {{item.currentStock}}
                          </span>
                          <span v-if="item.minStock > 0">/{{item.minStock}} <i v-if="item.currentStock < item.minStock" class="fas fa-exclamation-circle"></i></span>
                        </div>
                        <span v-else>
                          Child
                        </span>
                      </td>
<!--                      <td><span v-if="item.parentId === 0 && item.expectedEndDate !== null" @click="recalculateEndingDate(item)">{{dateText(item.expectedEndDate)}}</span></td>-->
                      <td><div v-if="item.parentId === 0" v-html="numberOfDaysToEnd(item)"></div></td>
                      <td><div v-if="item.parentId === 0 && item.inventoryExpiryDate !== null" style="min-width: 100px;">{{dateText(item.inventoryExpiryDate)}}</div></td>

                      <td :class="{'kh-11': item.supplierOrdered === true}"  @click="markAsSupplierOrdered(item)"><span v-if="item.supplierOrdered === true">Ordered</span><span v-else style="padding: 10px;">No</span></td>
                      <td><span v-if="item.lastStockInTime > 0">{{dateText(item.lastStockInTime)}}</span></td>
                      <td>{{(item.weight/100).toFixed(2)}}Kg</td>
                      <td @click="showBooleanSelectorView(item, 'available')">
                        <span v-if="item.available === true">Available</span>
                        <span v-else>N/A</span>
<!--                        <select v-model="item.available" style="height: 30px; width: 80px; line-height: 30px; text-align: center;">-->
<!--                          <option value="true">Available</option>-->
<!--                          <option value="false">N/A</option>-->
<!--                        </select>-->

                      </td>
                      <td>
                        <i v-if="item.canOrderKokoro===true" class="fas fa-check" style="color: green;"></i>
                        <i v-else class="fas fa-times" style="color: red;"></i>
                      </td>
                      <td>
                        <i v-if="item.canOrderVendor===true" class="fas fa-check" style="color: green;"></i>
                        <i v-else class="fas fa-times" style="color: red;"></i>
                      </td>

                      <td>{{(item.unitValue/100).toFixed(2)}}</td>
                      <td>{{(item.value/100).toFixed(2)}}</td>
<!--                      <td @click.stop="downloadProductStockReport(item)"><span>Stock Report</span></td>-->
<!--                      <td @click.stop="downloadProductMigrationStockReport(item)"><span>Test</span></td>-->

                    </tr>
                  </draggable>
                </table>
                </div>
              </div>


              <transition name="slide">
                <div class="col-6">
                  <div class="scroll-container" v-if="orderItem != false" style="padding-bottom: 100px;">
                    <div class="card">
                      <div class="basket-container">
                        <div class="basket-header">
                          ORDER BASKET
                        </div>
                        <div class="basket-body">
                          <table>
                            <tr>
                              <td>Merchant</td>
                              <td>
                                <select v-model="orderItem.merchantId">
                                  <option value="0">Select</option>
                                  <option v-for="merchant in merchants" :value="merchant.id">{{merchant.title}}</option>
                                </select>
                              </td>

                            </tr>
                            <tr>
                              <td>Delivery Date</td>
                              <td>
                                <input type="date" v-model="orderItem.deliveryDate"/>
                              </td>
                            </tr>
                          </table>

                          <table class="table">
                            <transition-group tag="tbody" name="slide">
                              <tr v-for="(item, index) in orderItem.list" :key="'order-row-' + item.title">
                                <td class="text-left">{{item.title}}</td>
                                <td>{{(item.price/100.00).toFixed(2)}}</td>
                                <td><span v-on:click="changeOrderAmount(index, 1)"><i class="fas fa-plus"></i></span></td>
                                <td><input type="number" v-model="item.amount" v-on:change="calculateOrder" style="width:70px;"/></td>
                                <td><span v-on:click="changeOrderAmount(index, -1)"><i class="fas fa-minus"></i></span></td>
                                <td>{{(item.totalPrice/100.00).toFixed(2)}}</td>
                                <td>{{(item.taxRate/100.00).toFixed(2)}}</td>
                                <td>{{(item.tax/100.00).toFixed(2)}}</td>
                              </tr>
                            </transition-group>
                            <tr>
                              <th>TOTAL</th>
                              <th></th>
                              <th></th>
                              <th>{{orderItem.amount}}</th>
                              <th></th>
                              <th>{{(orderItem.totalPrice/100.00).toFixed(2)}}</th>
                              <th></th>
                              <th>{{(orderItem.tax/100.00).toFixed(2)}}</th>
                            </tr>
                          </table>

                          <div class="container">
                            <div class="row">
                              <div class="col-12 text-right">
                                <button class="btn btn-dark" style="float:left;" v-on:click="closeOrderBasket"><i class="fas fa-times" style="color:white;"> Close</i></button>
                                <button class="btn btn-danger" v-on:click="deleteOrder"><i class="fas fa-trash"> Delete</i></button>
                                <button class="btn btn-primary" v-on:click="submitOrderBasket">Submit</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>



            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="slideup">
      <div class="item-container " v-if="editProductItem != false" style="padding-bottom: 30px;" v-on:click="closeProductEdit">
        <div class="card" style="margin-top: 10px; margin-left: auto; margin-right: auto; width:calc(100% - 80px);" v-on:click.stop="dummy">
          <div class="card-header" style="position: sticky; top:0; z-index:10; background-color: #D2D2D2;">
            <div class="container-fluid">
              <div class="row">
                <div class="col-6 text-left" style="font-size: 20px; font-weight: bold;">
                  {{editProductItem.originalTitle}}
                  <span v-if="editProductItem.id > 0">#{{editProductItem.id}}</span>


                </div>
                <div class="col-6 text-right border-btn-container">
                  <span v-if="editProductItem.expectedEndDate !== null && editProductItem.expectedEndDate.length > 0" style="margin-right:20px;font-size: 20px; font-weight: bold;">Stock End Date: {{dateText(editProductItem.expectedEndDate)}}</span>
                  <template v-if="editProductItem.deleted === false">
                    <span class="border-btn" v-if="editProductItem.id > 0" v-on:click="askDeleteProduct(editProductItem)"><i class="fas fa-trash"></i>Delete</span>
                    <span class="border-btn" v-on:click="updateProduct"><i class="fas fa-save"></i>Save</span>
                  </template>
                  <span class="border-btn" v-on:click="closeProductEdit"><i class="fas fa-close"></i>Close</span>

                </div>
              </div>
            </div>
          </div>
          <div class="card-body pt-0 pb-0" style="padding-left: 0; padding-right: 0;">
            <table style="width: 100%; height: 100%;">
              <tr style="height: 100%;">
                <td style="width: 33.33%; height: 100%;">
                  <div class="container h-100" style="overflow-y: auto;">
                    <div class="row" v-if="editProductItem.deleted === false && editProductItem.id > 0" style="padding-top: 20px;">
                      <div class="col-12 text-left">

                        <b>Images</b>
                        <div class="image-list-container">
                          <div class="image-item" v-if="editProductItem.imageUrls.length > 0" v-for="(img, index) in editProductItem.imageUrls" v-bind:style="{ backgroundImage: 'url(' + img +')'}">
                            <i class="fas fa-trash top-left-icon" v-on:click="onImageDeleted(index)"></i>
                          </div>

                          <div class="image-control">
                            <progress value="0" max="100" id="uploader"></progress>
                            <br>
                            <input accept="image/*" type="file" ref="file" value="upload" @change="fileBtn"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-row">
<!--                      <label class="col-4 form-control"></label>-->
                      <div class="col-12">
                        <b>Category</b>
                        <select v-model="editProductItem.categoryId" class="form-control" :disabled="editProductItem.deleted === true">
                          <!--                            <template v-for="cat in categories">-->
                          <option v-for="cat in categories" :value="cat.id">{{cat.title}}</option>
                          <!--                            </template>-->
                        </select>
                      </div>

                    </div>
                    <div class="row form-row" v-if="editProductItem.children.length == 0">
<!--                      <label class="col-4 form-control">Parent</label>-->
                      <div class="col-12 text-left">
                        <b>Parent Product</b>
                        <label class="form-control" style="background-clip: padding-box; border: 1px solid #ced4da;" v-if="editProductItem.parentId > 0 && editProductItem.parent != null"><span v-if="editProductItem.parent.code != null && editProductItem.parent.code.length > 0">[{{editProductItem.parent.code}}]</span>{{editProductItem.parent.title}}</label>
                        <label class="form-control" style="background-clip: padding-box; border: 1px solid #ced4da;" v-else>None</label>
                      </div>
                      <button class="col-1 form-control btn btn-danger" v-if="editProductItem.parentId > 0 && editProductItem.deleted === false" v-on:click="editProductItem.parentId = 0; editProductItem.parent = null">Unset</button>

                      <div class="col-12">
                        <b>Stock Quantity</b>
                        <input class="form-control" v-model="editProductItem.stockQuantity"/>
                      </div>

                    </div>
                    <div class="row form-row" style="margin-top: 15px;" v-if="editProductItem.children.length == 0 && editProductItem.deleted === false">
                      <div class="col-12 pt-0 pb-0" style="margin-top: 0;"><b>Parent Search</b></div>
                      <div class="col-8 pt-0" style="margin-top: 0;">

                        <input type="text" class="form-control" v-model="parentSearchWord" v-on:keyup="onParentSearch"/>
                      </div>

                      <div class="col-4 pt-0 form-control text-left" style="border:none; margin-top:0;"><span v-on:click="cancelParentSearch" style="padding-left:10px; padding-right:10px; cursor: pointer;"><i class="fas fa-times"></i></span></div>
                    </div>
                    <div class="row form-row" style="padding-bottom: 10px;" v-if="editProductItem.children.length > 0">

                      <div class="col-12" style="display: inline-block; padding:5px; border:1px solid grey; border-radius: 5px;">
                        <b>Children</b>
                        <div style="float:left; padding:10px; margin-left:5px; margin-bottom: 5px; border:1px solid grey; border-radius: 5px; " v-for="c in editProductItem.children">{{c.title}}</div>
                      </div>
                    </div>
                    <div class="row form-row" v-if="parentSearchList.length > 0 && editProductItem.deleted === false">
                      <div class="col-4"></div>
                      <div class="col-8">
                        <li class="list-group">
                          <ul class="list-group-item" v-for="pc in parentSearchList" v-if="pc.parentId === 0 && editProductItem.id !== pc.id" v-on:click="onParentSelected(pc)"><span v-if="pc.code != null && pc.code.length > 0">[{{pc.code}}]</span>{{pc.title}}</ul>
                        </li>
                      </div>
                    </div>
                    <div class="row form-row" >
                      <div class="col-12">
                        <b>Code</b>
                        <input type="text" class="form-control" v-model="editProductItem.code" :disabled="editProductItem.deleted === true"/>
                      </div>
                    </div>
                    <div class="row form-row" >
                      <div class="col-12">
                        <b>Product Name</b>

                        <input type="text" class="form-control" v-model="editProductItem.title" :disabled="editProductItem.deleted === true"/>
                      </div>
                    </div>
                    <div class="row form-row" v-if="editProductItem.id > 0" >
                      <div class="col-12">
                        <b>Product ID</b>
                        <input type="text" class="form-control" v-model="editProductItem.id" :disabled="editProductItem.deleted === true" disabled/>
                      </div>


                    </div>
                    <div class="row form-row" style="display: none;">
                      <div class="col-12">
                        <b>Tags</b>(Search, type and press enter key)
                        <input-tag :key="'tags' + editProductItem.id" class="form-control" v-model="editProductItem.tags"></input-tag>
                      </div>


                    </div>

<!--                    <div class="row form-row" style="display: none;">-->
<!--                      <div class="col-12">-->
<!--                        <b>Vendors</b>-->
<!--                        <select class="form-control" v-model="editProductItem.vendorId">-->
<!--                          <option value="0">Select Vendor</option>-->
<!--                          <option v-for="v in vendors" :value="v.id">{{v.title}}</option>-->
<!--                        </select>-->
<!--                      </div>-->

<!--                    </div>-->
                    <div class="row form-row">
                      <div class="col-12">
                        <b>Vendores</b>
                        <div class="tag-container" style="width: 100%;">
                          <div class="selected-tag" v-for="v in editProductItem.vendors">{{v.title}} <span v-on:click="removeVendor(v)" v-if="editProductItem.deleted === false"><i class="fas fa-trash"></i></span></div>
                        </div>
                        <div class="tag-container" v-if="editProductItem.deleted === false">
                          <div class="tag-item" v-for="v in vendors" v-if="isVendorSelected(v)==false" v-on:click="vendorSelected(v)">{{v.title}}</div>
                        </div>
                      </div>

                    </div>

                    <div class="row form-row" style="margin-top: 20px;">
                      <div class="col-12">
                        <b>Suppliers</b>
                        <div class="tag-container" style="width: 100%;">
                          <div class="selected-tag" v-for="v in editProductItem.suppliers">{{v.title}} <span v-if="editProductItem.deleted === false" v-on:click="removeSupplier(v)"><i class="fas fa-trash"></i></span></div>
                        </div>

                        <div class="tag-container" v-if="editProductItem.deleted === false">
                          <div class="tag-item" v-for="v in suppliers" v-if="isSupplierSelected(v)==false" v-on:click="supplierSelected(v)">{{v.title}}</div>
                        </div>
                      </div>

                    </div>

                    <div class="row form-row" style="display: none;">
                      <div class="col-12">
                        <b>Description</b>
                        <textarea class="form-control" rows="3" v-model="editProductItem.description" :disabled="editProductItem.deleted === true"></textarea>
                      </div>


                    </div>
                  </div>
                </td>
                <td style="width: 33.33%; height: 100%; font-size: 18px; background: #f5f5f5;">

                  <div class="container h-100 large-font" style="overflow-y: auto; padding-top: 20px;">
                    <div class="row form-row">
                      <div class="col-12" style="padding-bottom: 10px;">
                        Color
                        <div style="display: flex;">
                          <div style="width: 16.6%; height: 50px;" class="product-title-bg-0 product-bg-selector" :class="{'unselected': editProductItem.productColourCode !== 0}" @click="editProductItem.productColourCode = 0"/>
                          <div style="width: 16.6%; height: 50px;" class="product-title-bg-1 product-bg-selector" :class="{'unselected': editProductItem.productColourCode !== 1}" @click="editProductItem.productColourCode = 1"/>
                          <div style="width: 16.6%; height: 50px;" class="product-title-bg-2 product-bg-selector" :class="{'unselected': editProductItem.productColourCode !== 2}" @click="editProductItem.productColourCode = 2"/>
                          <div style="width: 16.6%; height: 50px;" class="product-title-bg-3 product-bg-selector" :class="{'unselected': editProductItem.productColourCode !== 3}" @click="editProductItem.productColourCode = 3"/>
                          <div style="width: 16.6%; height: 50px;" class="product-title-bg-4 product-bg-selector" :class="{'unselected': editProductItem.productColourCode !== 4}" @click="editProductItem.productColourCode = 4"/>
                          <div style="width: 16.6%; height: 50px;" class="product-title-bg-5 product-bg-selector" :class="{'unselected': editProductItem.productColourCode !== 5}" @click="editProductItem.productColourCode = 5"/>

                        </div>
                      </div>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">Default Price</label>
                      <input v-model="editProductItem.priceFloat" type="number" class="col-8 form-control text-left"
                             :class="{'warning-input' : editProductItem.priceFloat !== editProductItem.prevPrice}"
                             @change="checkPriceChange"/>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">Current Price</label>
                      <label class="col-8 form-control text-left">
                        <span v-if="editProductItem.inventoryPriceFloat > 0">£{{editProductItem.inventoryPriceFloat.toFixed(2)}}</span>
                        <span class="attention-required" v-else>Please set price on inventories</span>
                      </label>
                    </div>

                    <template v-if="user.viewProductCost === true">
                      <div class="row form-row">
                        <label class="col-4 form-control bold">Prime Cost</label>
                        <label class="col-8 form-control text-left">
                          <span v-if="editProductItem.inventoryUnitPriceFloat > 0">£{{editProductItem.inventoryUnitPriceFloat.toFixed(2)}}</span>
                          <span class="attention-required" v-else>{{editProductItem.sourcePriceFloat.toFixed(2)}}</span>
                        </label>
                      </div>
                      <div class="row form-row">
                        <label class="col-4 form-control bold">Margin Rate (%)</label>
                        <label class="col-3 form-control text-left">
                          <span v-if="editProductItem.inventoryMarginFloat > 0">{{editProductItem.inventoryMarginFloat.toFixed(2)}}%</span>
                          <span class="attention-required" v-else>{{(editProductItem.marginRate/100.0).toFixed(2)}}%</span>
                        </label>
                      </div>
                    </template>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">VAT</label>
                      <select class="col-8 form-control" v-model="editProductItem.taxRate" :disabled="editProductItem.deleted === true">
                        <option value="0">Zero Rated</option>
                        <option value="2000">20%</option>
                      </select>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">Weight (Kg)</label>
                      <input type="number" class="col-3 form-control text-left" v-model="editProductItem.weightFloat" :disabled="editProductItem.deleted === true"/>
                    </div>
                    <div class="row form-row" style="display: none;">
                      <label class="col-4 form-control">Barcode</label>
                      <div class="col-8" style="border:1px solid grey; padding-top:10px;padding-bottom:10px; margin-bottom: 10px;">
                        <barcode v-bind:value="generateProductBarcode(editProductItem)" v-bind:height="50">
                          Failed to generate
                        </barcode>
                      </div>
                    </div>
                    <div class="row form-row" style="display: none;">
                      <label class="col-4 form-control">Product Barcode</label>
                      <input type="text" class="col-8 form-control" v-model="editProductItem.productBarCode" :disabled="editProductItem.deleted === true"/>
                    </div>
                    <div class="row form-row" style="display: none;">
                      <label class="col-4 form-control">KOKORO Barcode</label>
                      <input type="text" class="col-8 form-control" v-model="editProductItem.barCode" :disabled="editProductItem.deleted === true"/>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">Stock type</label>
                      <select class="col-8 form-control" v-model="editProductItem.stockType" :disabled="editProductItem.deleted === true">
                        <option value="">Select</option>
                        <option value="stock">Stock item</option>
                        <option value="nonStock">Non stock item</option>
                      </select>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">Stock Unit Type</label>
                      <select class="col-8 form-control" v-model="editProductItem.stockUnitType" :disabled="editProductItem.deleted === true">
                        <option value="">N/A (Default EA)</option>
                        <option value="ea">EA</option>
                        <option value="kg">KG (Weight)</option>
                      </select>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">Unit Description</label>
                      <input type="text" class="col-8 form-control pb-0" v-model="editProductItem.unitDescription" :disabled="editProductItem.deleted === true"/>
                      <div class="col-12 mt-0" style="padding-top:0; font-size: small;padding-bottom: 20px; color: red;">This will be shown on shop order application.</div>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">Unit</label>
                      <input type="text" class="col-8 form-control" v-model="editProductItem.unit" :disabled="editProductItem.deleted === true"/>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold"><span v-if="editProductItem.unit != null && editProductItem.unit.length > 0">{{editProductItem.unit}} per unit</span><span v-else>Qty per Unit</span></label>
                      <input type="number" class="col-8 form-control text-left" v-model="editProductItem.unitAmount" :disabled="editProductItem.deleted === true"/>
                    </div>
                    <div class="row form-row">
                      <label class="col-4 form-control bold">Minimum stock</label>
                      <input type="number" class="col-8 form-control text-left" v-model="editProductItem.minStock" :disabled="editProductItem.deleted === true"/>
                    </div>
                    <div class="row form-row">
                      <div class="col-4">
                        <b>Shop can order to:</b>
                      </div>
                      <div class="col-4">
                        <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editProductItem.canOrderKokoro===true}" v-on:click="toggleBoolean('canOrderKokoro')">KTL</div>
                      </div>
                      <div class="col-4">
                        <div class="kh-btn kh-btn-smaller" :class="{'kh-9': editProductItem.canOrderVendor===true}"  v-on:click="toggleBoolean('canOrderVendor')">Vendors</div>
                      </div>
<!--                      <div class="col-8 text-left">-->
<!--                        <div style="height: 40px; line-height: 40px;" class="clickable" v-on:click="toggleBoolean('canOrderKokoro')"><span class="unchecked" v-bind:class="{'checked':editProductItem.canOrderKokoro==true}"><i class="fas fa-check-square"></i></span> Kokoro</div>-->
<!--                        <div style="height: 40px; line-height: 40px;" class="clickable" v-on:click="toggleBoolean('canOrderVendor')"><span class="unchecked" v-bind:class="{'checked':editProductItem.canOrderVendor==true}"><i class="fas fa-check-square"></i></span> Vendor</div>-->
<!--                      </div>-->

                    </div>
                    <div class="row form-row">
                      <div class="col-4">
                        <b>Show Border on app</b>
                      </div>
                      <div class="col-4">
                        <div class="kh-btn kh-btn-smaller" :class="{'kh-7': editProductItem.highlightProduct===false}" v-on:click=" editProductItem.highlightProduct = false">No Border</div>
                      </div>
                      <div class="col-4">
                        <div class="kh-btn kh-btn-smaller" :class="{'kh-9': editProductItem.highlightProduct===true}" v-on:click=" editProductItem.highlightProduct = true">Border</div>
                      </div>
                    </div>
                    <div class="row form-row" style="margin-top: 30px;">
                      <div class="col-4"><b>Price type</b></div>
                      <div class="col-4">
                        <div class="kh-btn kh-btn-smaller" :class="{'kh-4': editProductItem.useVariablePrice === false}" @click="setVariablePrice(false)">Normal</div>
                      </div>
                      <div class="col-4">
                        <div class="kh-btn kh-btn-smaller" :class="{'kh-9': editProductItem.useVariablePrice === true}" @click="setVariablePrice(true)">Weight Based</div>
                      </div>


<!--                      <label class="col-2 form-control">Unit: </label>-->
<!--                      <input type="text" class="col-3 form-control text-left" v-model="editProductItem.variablePriceUnit" :disabled="editProductItem.deleted === true"/>-->

                    </div>


                    <div class="row form-row" style="margin-top: 30px;">
                      <div class="col-4"><b>No margin tags</b></div>
                      <div class="col-6">
                        <input-tag type="text" class="form-control" v-model="editProductItem.noMarginTags" placeholder="TAGs"/>
                      </div>
                      <div class="col-12" style="color:red;">
                        No margin price will be applied to orders from shops with the same tag.
                      </div>
                    </div>

                    <div class="row">
                      <div v-for="tag in editProductItem.noMarginTags" class="col-12 text-left" :key="'product-' + editProductItem.id + '-tag-container-' + tag">
                        <b>#{{tag}}: </b> {{getMerchantWithTag(tag)}}

                      </div>
                    </div>

                  </div>
                </td>
                <td style="width: 33.33%; height: 100%; ">
                  <div class="container h-100" style="overflow-y: scroll;">
                    <div class="row">
                      <div class="col-12 section-header text-left" style="margin-top: 0;">
                        Setting for branches
                      </div>
                      <div class="col-12">
                        <table class="table text-left">
                          <tr>
                            <th>Shops
                              <select v-model="metaFilter" style="height: 30px; line-height: 30px; text-align: center; border: 1px solid #dadada; border-radius: 5px; font-size: 15px; margin-left: 10px;">
                                <option value="all">All</option>
                                <option value="kokoro">Kokoro</option>
                                <option value="jv">JV</option>
                                <option value="franchise">Franchise</option>
                                <option value="premier">Premier</option>
                                <option value="vendor">Vendor</option>
                                <option value="personal">Personal</option>
                                <option value="other">Other</option>
                              </select>
                            </th>
                            <th class="text-left"><span style="color:red; margin-left:20px; text-transform: capitalize;" v-on:click="changeAllMetas(false)">Disable {{metaFilter}}</span></th>
                            <th><span style="color:green; margin-left:20px; text-transform: capitalize;" v-on:click="changeAllMetas(true)">Enable {{metaFilter}}</span></th>
                            <th style="display: none;">Margin(%)</th>
                            <th style="display: none;">Price</th>
                          </tr>
                          <tr style="background-color: #B8E58B; display: none;">
                            <td>Default</td>
                            <td colspan="2">
                              <span v-if="editProductItem.available === true" style="color:green;"><i class="fas fa-check"></i> Show</span>
                              <span v-else style="color:red;"><i class="fas fa-times"></i> Hide</span>
                              <!--                        <span v-if="editProductItem.available == true"><i class="fas fa-check" style="color:green;"></i></span>-->
                              <!--                        <span v-else><i class="fas fa-times" style="color:red;"></i></span>-->
                            </td>
                            <td><input type="number" class="text-right" style="width:80%;max-width:100px;" v-model="editProductItem.marginRate"/> %</td>
                            <td>{{(parseFloat(editProductItem.sourcePrice)*editProductItem.marginRate*100/10000 + parseFloat(editProductItem.sourcePrice)).toFixed(2)}}</td>
                            <!--                                <td><input type="number" class="form-control text-right" v-model="editProductItem.price"/></td>-->
                          </tr>
                          <template v-for="(m, mi) in editProductItem.metaList">


                            <tr :key="'meta-row-'+m.id" v-if="metaFilter === 'all' || metaFilter === m.merchant.type">
                              <td>{{getMerchantName(m.merchantId)}}</td>
                              <td colspan="2">
                                <div class="kh-btn kh-btn-smaller kh-10" v-if="m.available === true" @click="setMerchantAvailability(mi)">SHOW</div>
                                <div class="kh-btn kh-btn-smaller kh-9" v-else  @click="setMerchantAvailability(mi)">HIDE</div>
  <!--                              <select v-model="m.available" :class="{'kh-10':m.available === true, 'kh-9':m.available === false}" style="padding: 5px 10px;" @change="toggleMerchantAvailable(mi)">-->
  <!--                                <option value="false">HIDE</option>-->
  <!--                                <option value="true">SHOW</option>-->
  <!--                              </select>-->
                                <!--                        <span v-if="m.available == true" style="color:green;"><i class="fas fa-check"></i> Show</span>-->
                                <!--                        <span v-else style="color:red;"><i class="fas fa-times"></i> Hide</span>-->
                                <!--                        <span v-if="m.available == true"><i class="fas fa-check" style="color:green;"></i></span>-->
                                <!--                        <span v-else><i class="fas fa-times" style="color:red;"></i></span>-->
                              </td>
                              <td style="display: none;"><input type="number" class="text-right" style="width:80%;max-width:100px;" v-model="m.marginRate" @change="updateMerchantMeta(mi)" :disabled="editProductItem.deleted === true"/> %</td>
                              <td style="display: none;">{{(parseFloat(editProductItem.sourcePrice)*m.marginRate*100/10000 + parseFloat(editProductItem.sourcePrice)).toFixed(2)}}</td>

                              <!--                                <td></td>-->
                            </tr>
                          </template>
                        </table>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

            </table>
          </div>
        </div>
      </div>

    </transition>
    <transition name="slideup">
      <div class="item-container " v-if="stockView !== false" style="padding-bottom: 50px;" v-on:click="closeStockView">
        <div style="width: calc(100% - 20px); height: calc(100% - 20px); background: white; margin: 10px;" @click.stop="dummy">
          <div style="width: 100%; height: 50px;">
            <table style="width: 100%;">
              <tr>
                <td style="height: 50px; font-size: 1.3rem;">
                  <strong>STOCK: {{stockView.product.title}}</strong> #{{stockView.product.id}}
                </td>

                <td style="padding-right: 20px;">
                  <button class="btn btn-dark" style="float:right;" v-on:click="closeStockView">Close</button>
                </td>
              </tr>

            </table>




          </div>
          <div style="width: 100%; height: 50px;">
            <table style="width: 100%;">
              <tr>
                <td style="padding-left: 30px;">
                  <button @click="changeStockViewType('inventories')" class="tab" :class="{'active': stockViewType === 'inventories'}">Inventories</button>
                  <button @click="changeStockViewType('stocks')" class="tab" :class="{'active': stockViewType === 'stocks'}">In/Out Records</button>
                </td>
                <template v-if="stockViewType === 'inventories'">
                  <td>
                  <button class="btn kh-10" @click="openInventoryItemFormView(stockView.product)">+ Add Inventory</button>
                  </td>
                  <td class="text-right">
                    <span style="height: 50px; line-height: 50px;">Change Order</span>
                  </td>
                  <td class="text-left">
                      <label class="switch" :class="{'enabled': stockView.draggable === true}" @click="stockView.draggable = !stockView.draggable">
                        <!--                  <input type="checkbox">-->
                        <span class="slider round"></span>
                      </label>

                  </td>
                </template>
                <td v-else-if="stockViewType === 'stocks'">
                  <date-picker v-model="stockDateRange" valueType="format" range></date-picker>
                  <select v-model="stockType">
                    <option value="all">All</option>
                    <option value="stock_in">In</option>
                    <option value="stock_out">Out</option>
                    <option value="stock_correction">Correction</option>
                    <option value="return">Return</option>
                    <option value="disposal">Disposal</option>
                    <option value="cancel_order">Order Cancel</option>
                    <option value="return_to_vendor">Return to vendor</option>
                  </select>
                  <button v-on:click.stop="getStockList(stockView.product.id)" style="margin-right:50px;">GET</button>
                </td>
              </tr>
            </table>

          </div>
          <div style="width: 100%; height: calc(100% - 100px);">
            <div v-if="stockViewType === 'inventories'" style="width: 100%; height: 100%">

              <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">
                <table style="width: 100%;" class="inventory-table">
                  <tr>
                    <th>ID</th>
                    <th>Stocked In</th>
                    <th>Vendor</th>
                    <th>Location</th>
                    <th>Batch Code</th>
                    <th>Expiry</th>
                    <th>Balance</th>
                    <th v-if="stockView.product.useVariablePrice === true">Weight Balance</th>
                    <th>In</th>

                    <th v-if="stockView.product.useVariablePrice === true">In Weight</th>
                    <th>By</th>
                    <th>Selling Price</th>
                    <th>Unit Prime Cost</th>
                    <th>Total Value</th>
                  </tr>
<!--                  <tbody>-->


                  <draggable v-model="stockView.inventories" :group="stockView.inventories" :options="{disabled: stockView.draggable === false, animation:300}" @change="onOrderChanged" tag="tbody">


                  <tr  v-for="inv in stockView.inventories" :key="'product-' + stockView.product.id + '-inventory-row-' + inv.id" @click="openInventoryItemView(stockView.product, inv)">
                    <td>{{inv.id}}</td>
                    <td>{{getTimeString(inv.stockInTime)}}</td>
                    <td>{{inv.vendorTitle}}</td>
                    <td>{{inv.area}} - {{inv.location}} - {{inv.section}}</td>
                    <td>{{inv.batchCode}}</td>
                    <td>{{getDateString(inv.expiryDate)}}</td>
                    <td>{{inv.balance}}</td>
                    <td v-if="stockView.product.useVariablePrice === true">{{inv.weightBalanceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    <td>{{inv.originalBalance}}</td>
                    <td v-if="stockView.product.useVariablePrice === true">{{(inv.weight/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    <td><span v-if="inv.inBy !== null">{{inv.inBy}}</span></td>
                    <td>
                      <span v-if="inv.sellingPriceFloat > 0">{{inv.sellingPriceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                      <span v-else style="color:red;">{{stockView.product.priceFloat}} (not set)</span>
                    </td>
                    <td>
                      <span v-if="stockView.product.useVariablePrice === true">
                        {{inv.pricePerWeightFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                      </span>
                      <span v-else>
                        {{inv.unitPriceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                      </span>
                    </td>
                    <td>{{inv.valueFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                  </tr>
                  </draggable>
<!--                  </tbody>-->
                  <template v-if="stockView.inactiveInventories.length > 0">
                    <tr style="padding-top: 20px;">
                      <td colspan="14" style="padding-top: 30px; font-weight: bold; border-top: 1px solid black;">Inactive Inventories</td>
                    </tr>

                  </template>
                  <tr  v-for="inv in stockView.inactiveInventories" :key="'product-' + stockView.product.id + '-inventory-row-' + inv.id" @click="openInventoryItemView(stockView.product, inv)">
                    <td>{{inv.id}}</td>
                    <td>{{getTimeString(inv.stockInTime)}}</td>
                    <td>{{inv.vendorTitle}}</td>
                    <td>{{inv.area}} - {{inv.location}} - {{inv.section}}</td>
                    <td>{{inv.batchCode}}</td>
                    <td>{{getDateString(inv.expiryDate)}}</td>
                    <td>{{inv.balance}}</td>
                    <td v-if="stockView.product.useVariablePrice === true">{{inv.weightBalanceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    <td>{{inv.originalBalance}}</td>
                    <td v-if="stockView.product.useVariablePrice === true">{{inv.weight.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    <td><span v-if="inv.inBy !== null">{{inv.inBy}}</span></td>
                    <td>{{inv.sellingPriceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    <td>
                      <span v-if="stockView.product.useVariablePrice === true">
                        {{inv.pricePerWeightFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                      </span>
                      <span v-else>
                        {{inv.unitPriceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                      </span>
                    </td>
                    <td>{{inv.valueFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                  </tr>

                  <template v-if="stockView.oldInventories.length > 0">
                    <tr style="padding-top: 20px;">
                      <td colspan="14" style="padding-top: 30px; font-weight: bold; border-top: 1px solid black;">Old Inventories</td>
                    </tr>

                  </template>
                  <tr  v-for="inv in stockView.oldInventories" :key="'product-' + stockView.product.id + '-inventory-row-' + inv.id" @click="openInventoryItemView(stockView.product, inv)">
                    <td>{{inv.id}}</td>
                    <td>{{getTimeString(inv.stockInTime)}}</td>
                    <td>{{inv.vendorTitle}}</td>
                    <td>{{inv.area}} - {{inv.location}} - {{inv.section}}</td>
                    <td>{{inv.batchCode}}</td>
                    <td>{{getDateString(inv.expiryDate)}}</td>
                    <td>{{inv.balance}}</td>
                    <td v-if="stockView.product.useVariablePrice === true">{{inv.weightBalanceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    <td>{{inv.originalBalance}}</td>
                    <td v-if="stockView.product.useVariablePrice === true">{{inv.weight.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    <td><span v-if="inv.inBy !== null">{{inv.inBy}}</span></td>
                    <td>{{inv.sellingPriceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                    <td>
                      <span v-if="stockView.product.useVariablePrice === true">
                        {{inv.pricePerWeightFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                      </span>
                      <span v-else>
                        {{inv.unitPriceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                      </span>
                    </td>
                    <td>{{inv.valueFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                  </tr>
                </table>
              </div>


              <div style="width: 100%; height: 100px; display: flex;">
                <template v-if="stockView.product.useVariablePrice === true">
                  <div style="width: 25%;" class="kh-10">
                    <div class="stock-view-quantity-title">Inventory</div>
                    <div class="stock-view-quantity weight">{{stockView.inventoryQuantity.toLocaleString()}} fillets / {{(stockView.inventoryWeight/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} <span style="font-size: 15px;">kg</span></div>
                  </div>
                  <div style="width: 25%;" class="kh-9">
                    <div class="stock-view-quantity-title">Picking</div>
                    <div class="stock-view-quantity weight" style="text-decoration: underline; cursor: pointer;" @click="openProductMidstockView(stockView.product)">{{stockView.midStockQuantity.toLocaleString()}} fillets / {{(stockView.midStockWeight/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}  <span style="font-size: 15px;">kg</span></div>
                  </div>
                  <div style="width: 25%;" class="kh-8">
                    <div class="stock-view-quantity-title">Order Qty</div>
                    <div class="stock-view-quantity weight">{{stockView.orderQuantity}} fillets</div>
                  </div>
                  <div style="width: 25%;" class="kh-5">
                    <div class="stock-view-quantity-title">Available</div>
                    <div class="stock-view-quantity weight">{{stockView.availableQuantity.toLocaleString()}} fillets / {{(stockView.availableWeight/100.0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}  <span style="font-size: 15px;">kg</span></div>
                  </div>
                </template>
                <template v-else>
                  <div style="width: 25%;" class="kh-10">
                    <div class="stock-view-quantity-title">Inventory</div>
                    <div class="stock-view-quantity">{{stockView.inventoryQuantity.toLocaleString()}}</div>
                  </div>
                  <div style="width: 25%;" class="kh-9">
                    <div class="stock-view-quantity-title">Picking</div>
                    <div class="stock-view-quantity" style="text-decoration: underline; cursor: pointer;" @click="openProductMidstockView(stockView.product)">{{stockView.midStockQuantity.toLocaleString()}}</div>
                  </div>
                  <div style="width: 25%;" class="kh-8">
                    <div class="stock-view-quantity-title">Order Qty</div>
                    <div class="stock-view-quantity">{{stockView.orderQuantity.toLocaleString()}}</div>
                  </div>
                  <div style="width: 25%;" class="kh-5">
                    <div class="stock-view-quantity-title">Available</div>
                    <div class="stock-view-quantity">{{stockView.availableQuantity.toLocaleString()}}</div>
                  </div>
                </template>


              </div>
            </div>
            <div v-else-if="stockViewType === 'stocks'" style="width: 100%; height: 100%; overflow-y: auto;">
              <table class="table">
                <tr>
                  <!--                <th>#</th>-->
                  <th>Type</th>
                  <th>처리일</th>
                  <th>Date</th>
                  <th></th>
                  <th>Previous</th>
                  <th>Qty</th>
                  <th>Balance</th>
                  <th v-if="stockView.product.useVariablePrice === true">Prev Weight</th>
                  <th v-if="stockView.product.useVariablePrice === true">KG</th>
                  <th v-if="stockView.product.useVariablePrice === true">Balance Weight</th>

                  <th>Order#</th>
                  <th>Order Item#</th>
                  <th>Inventory</th>
                  <th>PO#</th>
                  <th>Net</th>
                  <th>Vat</th>
                  <th>Gross</th>
                  <th class="text-left">Shop</th>
                  <th>Vendor</th>
                  <th>By</th>
                  <th></th>
                  <th>Unit Value</th>
                  <th>Value</th>

                </tr>
                <tr v-for="s in stockView.stocks">
                  <!--                <td>{{s.id}}</td>-->
                  <td v-html="getStockIcon(s)"></td>
                  <td>{{getTimeString(s.createdTimestamp)}}</td>
                  <td>{{s.stockDate}}</td>
                  <td><span v-if="s.documents.length > 0" style="padding-left: 10px; padding-right: 10px;"><a :href="s.documents[0]" target="_blank"><i class="fas fa-file"></i></a></span></td>
                  <td>
                    {{s.previousBalance}}
                  </td>
                  <td>
                    {{s.diff}}
                  </td>
                  <td>
                    {{s.balance}}

                  </td>
                  <td v-if="stockView.product.useVariablePrice === true">
                    {{(s.previousBalanceWeight/100.0)}} kg
                  </td>

                  <td v-if="stockView.product.useVariablePrice === true">
                    {{(s.diffWeight/100.0).toFixed(2)}} Kg
                  </td>

                  <td v-if="stockView.product.useVariablePrice === true">
                    {{(s.balanceWeight/100.0).toFixed(2)}} Kg
                  </td>

                  <td>
                    <span v-if="s.invoice != null">{{s.invoice.title}}</span>

                    <span v-else-if="s.orderId > 0">{{s.orderId}}</span>
                    <span v-else-if="s.creditOrderId > 0">CR{{s.creditOrderId}}</span>
                  </td>
                  <td>
                    {{s.orderItemId}}
                  </td>
                  <td>
                    {{s.inventoryId}}
                  </td>
                  <td><span v-if="s.vendorOrderId > 0">{{s.vendorOrderId}}</span></td>
                  <td><span v-if="s.totalPrice != 0">{{(s.totalPrice/100.0).toFixed(2)}}</span></td>
                  <td><span>{{(s.taxRate/100.0).toFixed(0)}}%</span><span v-if="s.tax != 0">{{(s.tax/100.0).toFixed(2)}}</span></td>
                  <td><span v-if="s.finalDue !== 0">{{(s.finalDue/100.0).toFixed(2)}}</span></td>
                  <td class="text-left">{{getMerchantName(s.merchantId)}}</td>
                  <td><span v-if="s.vendorId > 0">{{getVendorName(s.vendorId)}}</span></td>
                  <td>{{s.userName}}</td>
                  <td><span v-on:click="editStock(s)"><i class="fas fa-edit"></i></span></td>
                  <td>{{(s.unitValue/100.0).toFixed(2)}}</td>
                  <td>
                  <span v-if="s.stockUnitType !== null && s.stockUnitType === 'kg'">
                    {{(s.value/100.0).toFixed(2)}}
                  </span>
                    <span v-else>
                  {{(s.value/100.0).toFixed(2)}}
                  </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
<!--          <div style="width: 500px; height: 100%;">-->
<!--            <div style="width: 100%; height: 55px; line-height: 50px; background: #ddd; display: flex;">-->
<!--              <div style="padding-left: 20px;line-height: 50px; font-size: 20px; font-weight: bold;">Inventories</div>-->
<!--              <div style="padding-right: 20px; margin-left: auto;">-->
<!--               <button class="btn btn-success" @click="openInventoryItemFormView(stockView.product)">+ New</button>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="width: 100%; height: calc(100% - 155px); overflow-y: auto;">-->
<!--              <template v-if="stockView.inventories.length > 0">-->
<!--                <div class="inventory-card" v-for="inv in stockView.inventories" :key="'product-' + stockView.product.id + '-inventory-' + inv.id" @click="openInventoryItemView(stockView.product, inv)">-->
<!--                  <div class="inv-title">-->
<!--                    #{{inv.id}}-->
<!--                  </div>-->
<!--                  <div class="inv-location">-->
<!--                    {{inv.area}} - {{inv.location}} - {{inv.section}}-->
<!--                  </div>-->
<!--                  <div class="inv-description">-->
<!--                    Batch Code: {{inv.batchCode}}-->

<!--                  </div>-->
<!--                  <div class="inv-description">-->
<!--                    Expiry: {{inv.expiryDate}}-->
<!--                  </div>-->
<!--                  <template v-if="stockView.product.useVariablePrice === true">-->
<!--                  <div class="inv-balance">-->
<!--                      <div class="cur-bal">-->
<!--                        <div>{{inv.weightBalanceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}<span style="font-size: 15px;">kg</span></div>-->

<!--                      </div>-->
<!--                      <div class="orig-bal" style="padding: 10px;">-->
<!--                        <div>-->

<!--                          <div class="inv-price text-right">-->
<!--                            £{{inv.pricePerWeightFloat.toFixed(2)}}/kg-->
<!--                          </div>-->

<!--                        </div>-->

<!--                        <div>-->

<!--                          <div class="inv-price text-right">-->
<!--                            Value: £{{inv.weightValueFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="inv-balance">-->


<!--                    </div>-->
<!--                  </template>-->
<!--                  <template v-else>-->
<!--                    <div class="inv-balance">-->
<!--                      <div class="cur-bal">-->
<!--                        {{inv.balance.toLocaleString()}}-->

<!--                      </div>-->
<!--                      <div class="orig-bal" style="padding: 10px;">-->
<!--                        <div>-->
<!--                          <div class="inv-price text-right">-->
<!--                            £{{inv.unitPriceFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}/item-->
<!--                          </div>-->

<!--                        </div>-->

<!--                        <div>-->

<!--                          <div class="inv-price text-right">-->
<!--                            Value: £{{inv.valueFloat.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="inv-balance">-->


<!--                    </div>-->
<!--                  </template>-->
<!--                  <div class="inv-tile">-->
<!--                    <span style="font-size: 1.2rem; font-weight: bold;" v-if="stockView.product.useVariablePrice === true">{{inv.weightFloat.toFixed(2)}}kg</span><span v-else  style="font-size: 1.2rem; font-weight: bold;">{{inv.originalBalance}}</span> Stocked In {{getTimeString(inv.stockInTime)}}-->
<!--                  </div>-->
<!--&lt;!&ndash;                  <div class="inv-detail">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div>&ndash;&gt;-->
<!--&lt;!&ndash;                      {{inv.inQuantity}}&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <div>&ndash;&gt;-->
<!--&lt;!&ndash;                      {{inv.outQuantity}}&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->

<!--&lt;!&ndash;                  </div>&ndash;&gt;-->

<!--                </div>-->
<!--              </template>-->
<!--            </div>-->

<!--          </div>-->
<!--          <div style="width: calc(100% - 500px); height: 100%;">-->
<!--            <div class="card">-->
<!--              <div class="card-header text-right" style="position: sticky; top:0; z-index:10; background-color: #D2D2D2;">-->
<!--                <span style="float:left;"><strong>STOCK: {{stockView.product.title}}</strong> #{{stockView.product.id}}</span>-->

<!--                <date-picker v-model="stockDateRange" valueType="format" range></date-picker>-->
<!--                <select v-model="stockType">-->
<!--                  <option value="all">All</option>-->
<!--                  <option value="stock_in">In</option>-->
<!--                  <option value="stock_out">Out</option>-->
<!--                  <option value="stock_correction">Correction</option>-->
<!--                  <option value="return">Return</option>-->
<!--                  <option value="disposal">Disposal</option>-->
<!--                  <option value="cancel_order">Order Cancel</option>-->
<!--                  <option value="return_to_vendor">Return to vendor</option>-->
<!--                </select>-->
<!--                <button v-on:click.stop="getStockList(stockView.product.id)" style="margin-right:50px;">GET</button>-->
<!--&lt;!&ndash;                <label>Add Stock:</label>&ndash;&gt;-->
<!--&lt;!&ndash;                <button class="btn btn-primary" v-on:click="newStock('stock_in')"><i class="fas fa-plus"></i> In</button>&ndash;&gt;-->
<!--&lt;!&ndash;                <button class="btn btn-danger" v-on:click="newStock('stock_out')"><i class="fas fa-minus"></i> Out</button>&ndash;&gt;-->
<!--&lt;!&ndash;                <button class="btn btn-success" style="margin-right:70px;" v-on:click="newStock('stock_correction')"><i class="fas fa-wrench"></i> Correction</button>&ndash;&gt;-->
<!--                <button class="btn btn-dark" v-on:click="closeStockView">Close</button>-->
<!--              </div>-->
<!--              <div class="card-body" style="padding-left: 0; padding-right: 0;">-->
<!--                <table class="table">-->
<!--                  <tr>-->
<!--                    &lt;!&ndash;                <th>#</th>&ndash;&gt;-->
<!--                    <th>Type</th>-->
<!--                    <th>처리일</th>-->
<!--                    <th>Date</th>-->
<!--                    <th>Previous</th>-->
<!--                    <th><span v-if="stockView.product.useVariablePrice === true">KG</span><span v-else>Qty</span></th>-->
<!--                    <th>Balance</th>-->
<!--                    <th>Order#</th>-->
<!--                    <th>Order Item#</th>-->
<!--                    <th>Inventory</th>-->
<!--                    <th>PO#</th>-->
<!--                    <th>Net</th>-->
<!--                    <th>Vat</th>-->
<!--                    <th>Gross</th>-->
<!--                    <th class="text-left">Shop</th>-->
<!--                    <th>Vendor</th>-->
<!--                    <th>By</th>-->
<!--                    <th></th>-->
<!--                    <th>Unit Value</th>-->
<!--                    <th>Value</th>-->

<!--                  </tr>-->
<!--                  <tr v-for="s in stockView.stocks">-->
<!--                    &lt;!&ndash;                <td>{{s.id}}</td>&ndash;&gt;-->
<!--                    <td v-html="getStockIcon(s)"></td>-->
<!--                    <td>{{getTimeString(s.createdTimestamp)}}</td>-->
<!--                    <td>{{s.stockDate}}</td>-->
<!--                    <td>-->
<!--                      <span v-if="stockView.product.useVariablePrice === true">-->
<!--                        {{(s.previousBalanceWeight/100.0)}} kg-->
<!--                      </span>-->
<!--                      <span v-else>-->
<!--                        {{s.previousBalance}}-->
<!--                      </span>-->
<!--                    </td>-->
<!--                    <td>-->
<!--                  <span v-if="stockView.product.useVariablePrice === true">-->
<!--                    {{(s.diffWeight/100.0).toFixed(2)}} Kg-->
<!--                  </span>-->
<!--                      <span v-else>-->
<!--                  {{s.diff}}-->
<!--                  </span>-->

<!--                    </td>-->
<!--                    <td>-->
<!--                  <span v-if="stockView.product.useVariablePrice === true">-->
<!--                    {{(s.balanceWeight/100.0).toFixed(2)}} Kg-->
<!--                  </span>-->
<!--                      <span v-else>-->
<!--                    {{s.balance}}-->
<!--                  </span>-->
<!--                    </td>-->
<!--                    <td>-->
<!--                      <span v-if="s.invoice != null">{{s.invoice.title}}</span>-->

<!--                      <span v-else-if="s.orderId > 0">{{s.orderId}}</span>-->
<!--                      <span v-else-if="s.creditOrderId > 0">CR{{s.creditOrderId}}</span>-->
<!--                    </td>-->
<!--                    <td>-->
<!--                      {{s.orderItemId}}-->
<!--                    </td>-->
<!--                    <td>-->
<!--                      {{s.inventoryId}}-->
<!--                    </td>-->
<!--                    <td><span v-if="s.vendorOrderId > 0">{{s.vendorOrderId}}</span></td>-->
<!--                    <td><span v-if="s.totalPrice != 0">{{(s.totalPrice/100.0).toFixed(2)}}</span></td>-->
<!--                    <td><span>{{(s.taxRate/100.0).toFixed(0)}}%</span><span v-if="s.tax != 0">{{(s.tax/100.0).toFixed(2)}}</span></td>-->
<!--                    <td><span v-if="s.finalDue != 0">{{(s.finalDue/100.0).toFixed(2)}}</span></td>-->
<!--                    <td class="text-left">{{getMerchantName(s.merchantId)}}</td>-->
<!--                    <td><span v-if="s.vendorId > 0">{{getVendorName(s.vendorId)}}</span></td>-->
<!--                    <td>{{s.userName}}</td>-->
<!--                    <td><span v-on:click="editStock(s)"><i class="fas fa-edit"></i></span></td>-->
<!--                    <td>{{(s.unitValue/100.0).toFixed(2)}}</td>-->
<!--                    <td>-->
<!--                  <span v-if="s.stockUnitType !== null && s.stockUnitType === 'kg'">-->
<!--                    {{(s.value/100.0).toFixed(2)}}-->
<!--                  </span>-->
<!--                      <span v-else>-->
<!--                  {{(s.value/100.0).toFixed(2)}}-->
<!--                  </span>-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                </table>-->
<!--              </div>-->
<!--              <div class="card-footer text-right" style="position: sticky; bottom:0; background-color: #D2D2D2;">-->
<!--&lt;!&ndash;                <label>Add Stock:</label>&ndash;&gt;-->
<!--&lt;!&ndash;                <button class="btn btn-primary" v-on:click="newStock('stock_in')"><i class="fas fa-plus"></i> In</button>&ndash;&gt;-->
<!--&lt;!&ndash;                <button class="btn btn-danger" v-on:click="newStock('stock_out')"><i class="fas fa-minus"></i> Out</button>&ndash;&gt;-->
<!--&lt;!&ndash;                <button class="btn btn-success" style="margin-right: 70px;" v-on:click="newStock('stock_correction')"><i class="fas fa-wrench"></i> Correction</button>&ndash;&gt;-->

<!--                <button class="btn btn-dark" style="float:right;" v-on:click="closeStockView">Close</button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>

      </div>
    </transition>
    <transition name="slideup">
      <div class="form-background" v-if="stockUnitChangeForm !== false">
        <div class="form-container" style="width: 500px;max-width: 500px;">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <b>Change Stock Unit to KG (weight)</b>
              </div>
              <div class="col-12">
                {{stockUnitChangeForm.product.title}}
              </div>
              <div class="col-12">
                Total Weight in kg (#.##, in 2 decimal number)
                <input class="form-control" v-model="stockUnitChangeForm.weight"/>
              </div>
              <div class="col-12">
                Total Value
                <input class="form-control" v-model="stockUnitChangeForm.value"/>
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-6">
                <button class="btn btn-dark form-control" @click="stockUnitChangeForm = false">Cancel</button>
              </div>
              <div class="col-6">
                <button class="btn btn-success form-control" @click="submitStockUnitChange">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="form-background" v-if="editStockItem != false">
        <div class="form-container" style="width: 500px;max-width: 500px;">
          <div class="container">
            <div class="row text-left">
              <div class="col-12">
                <h4>Stock <span v-if="editStockItem.id > 0">#{{editStockItem.id}}</span></h4>
              </div>
            </div>
            <div class="row">
              <div class="col-4">Stock Type</div>
              <div class="col-8">
                <select class="form-control" v-model="editStockItem.type"  :disabled="editStockItem.id > 0">
                  <option value="">Select</option>
                  <option value="stock_in">Stock In</option>
                  <option value="stock_out">Stock Out</option>
                  <option value="in_house_disposal">In House Disposal</option>
                  <option value="stock_correction">Correction</option>
                  <option value="return">Customer Return</option>
                  <option value="disposal">Customer Disposal</option>
                  <option value="return_cancel">Return Cancel</option>
                  <option value="others">Others</option>
                </select>
              </div>
            </div>
            <div class="row" v-if="editStockItem.type === 'stock_correction'">
              <template v-if="editStockItem.stockUnitType !== null && editStockItem.stockUnitType === 'kg'">
                <div class="col-4">
                  New Stock Balance in Kg
                </div>
                <div class="col-8">
                  <input type="number" class="form-control text-left" v-model="editStockItem.amountWeightFloat" v-on:change="calculateStockItem"/>
                </div>
              </template>
              <template v-else>
                <div class="col-4">
                  New Stock Balance
                </div>
                <div class="col-8">
                  <input type="number" class="form-control text-left" v-model="editStockItem.amount" v-on:change="calculateStockItem"/>
                </div>
              </template>
            </div>
            <div class="row">
              <div class="col-4">
                Date
              </div>
              <div class="col-8">
                <input type="date" class="form-control text-left" v-model="editStockItem.stockDate"/>
              </div>
            </div>
          </div>
          <div class="container" v-if="editStockItem.type !== 'stock_correction'">
            <div class="row" v-if="editStockItem.stockUnitType !== null && editStockItem.stockUnitType === 'kg'">
              <div class="col-4">
                Total Weight (kg #.##)
              </div>
              <div class="col-8">
                <input type="number" class="form-control text-left" v-model="editStockItem.diffWeightFloat" :disabled="editStockItem.id > 0"/>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-4">
                Quantity
              </div>
              <div class="col-8">
                <input type="number" class="form-control text-left" v-model="editStockItem.diff" v-on:change="calculateStockItem"  :disabled="editStockItem.id > 0"/>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row" v-if="editStockItem.type == 'stock_in'">
              <div class="col-4">
                Vendor
              </div>
              <div class="col-8">
                <select class="form-control" v-model="editStockItem.vendorId" :disabled="editStockItem.id > 0">
                  <option value="0">Select</option>
                  <option v-for="v in vendors" :value="v.id">{{v.title}}</option>
                  <option v-for="v in suppliers" :value="v.id">{{v.title}}</option>
                </select>
              </div>
            </div>
            <div class="row" v-if="editStockItem.type == 'stock_in'">
              <div class="col-4">

              </div>
              <div class="col-8">
                <button class="btn" v-bind:class="{'btn-danger': editStockItem.noVendorRequired === true}" @click="editStockItem.noVendorRequired = true">Agree to No Vendor</button>
                <button class="btn"  v-bind:class="{'btn-primary': editStockItem.noVendorRequired === false}" @click="editStockItem.noVendorRequired = false">Vendor Required</button>
              </div>
            </div>
            <div class="row" v-if="editStockItem.stockUnitType !== null && editStockItem.stockUnitType === 'kg'">
              <div class="col-4">Unit Price</div>
              <div class="col-8">
                <input type="number" class="form-control text-left" v-model="editStockItem.unitPriceFloat" disabled/>
              </div>
            </div>
            <div class="row" v-else>

              <div class="col-4">Unit Price</div>
              <div class="col-8">
                <input type="number" class="form-control text-left" v-model="editStockItem.unitPriceFloat" v-on:change="calculateStockItem"/>
              </div>
            </div>
            <div class="row">

              <div class="col-4">
                NET Total:
              </div>
              <div class="col-8" v-if="editStockItem.stockUnitType !== null && editStockItem.stockUnitType === 'kg'">
                <input type="number" class="form-control text-left" v-model="editStockItem.totalPriceFloat" v-on:change="calculateStockItem"/>
              </div>
              <div class="col-8" v-else>
              {{(editStockItem.totalPrice/100.0).toFixed(2)}}
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <select class="form-control" v-model="editStockItem.taxRate" v-on:change="calculateStockItem">
                  <option value="0">VAT Zero</option>
                  <option value="2000">VAT 20%</option>
                </select>

<!--                VAT ({{editStockItem.taxRate == 0 ? 'Zero Rated' : (editStockItem.taxRate).toFixed(2) + '%'}}):-->
              </div>
              <div class="col-8">
                <div class="form-control">
                {{(editStockItem.tax/100.0).toFixed(2)}}
                  </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                Total:
              </div>
              <div class="col-8">
                {{(editStockItem.finalDue/100.0).toFixed(2)}}
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                메모:
              </div>
              <div class="col-8">
                <span v-if="editStockItem.id > 0 && editStockItem.description !== null && editStockItem.description.length > 0">{{editStockItem.description}}</span>
                <input v-else type="text" class="form-control" v-model="editStockItem.title"  :disabled="editStockItem.id > 0"/>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <button class="form-control btn btn-secondary" v-on:click="cancelStockItem"><i class="fa fa-close"> Close</i></button>
              </div>
              <div class="col-6">
                <button class="form-control btn btn-primary" v-on:click="submitStockItem"><i class="fa fa-save"> Submit</i></button>
              </div>
            </div>
            <div class="row" v-if="editStockItem.type === 'stock_in' && editStockItem.unitChangeable === true">
              <div class="col-12">
                <button class="btn btn-dark form-control" @click="setStockUnitChangeForm(editStockItem)">Change Stock Unit Type</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="form-background" v-if="editCategoryItem!=false">
      <div class="form-container" style="width: 500px;max-width: 500px;">
        <div class="container">
          <div class="row text-left">
            <div class="col-12">
              <h4>
                <span v-if="editCategoryItem.id == 0">Add Category</span>
                <span v-if="editCategoryItem.id > 0">{{editCategoryItem.title}}</span>
              </h4>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-12">
            Category Name
              <input class="form-control" v-model="editCategoryItem.title"/>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-12">
              Code (Categories will be listed in the order of code)
              <input class="form-control" v-model="editCategoryItem.code"/>
            </div>
          </div>
          <div class="row text-left" v-if="editCategoryItem.id > 0" style="display: none;">
            <div class="col-12">
            Move category
            <select class="form-control" v-model="editCategoryItem.parentId">
              <option value="0">To upper category</option>
              <option v-for="(cat, index) in categories" :value="cat.id">{{cat.title}}</option>
            </select>
            </div>
          </div>
<!--          <div class="row">-->
<!--            <label class="col-4 form-control">옵션</label>-->
<!--            <div class="col-8 text-left">-->
<!--              <span class="border-selector" v-bind:class="{'border-btn-selected': editCategoryItem.frontPage === true}" v-on:click="enableFrontPage()" >첫페이지</span>-->
<!--            </div>-->
<!--          </div>-->
          <div class="row" style="margin-top:30px;">

            <div class="col-12 text-left">

              <span class="border-btn" v-if="editCategoryItem.id > 0" v-on:click="deleteCategoryAsk"><i class="fa fa-trash"> Delete</i></span>
            </div>
            <div class="col-6">
              <button class="btn btn-secondary form-control" v-on:click="closeCategoryEdit"><i class="fa fa-close"> Close</i></button>

            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" v-on:click="submitCategoryEdit"><i class="fa fa-save"> Update</i></button>


            </div>

          </div>
        </div>


      </div>
    </div>
    <transition name="slideup">
      <div class="form-background" v-if="productDataView != false" @click="closeProductDataView">
        <div style="width: 90%; height: 90%; background: white; border-radius: 10px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" @click.stop="dummy">
          <product-trend-view
            :product="productDataView.product"
            :on-loaded="onProductUpdateNotified"
            :on-close="closeProductDataView"></product-trend-view>
        </div>
      </div>
    </transition>
    <div v-if="inventoryItemView !== false" style="width: 100%; height: 100%; z-index: 3; position: fixed; top: 0; left: 0; background: rgba(0,0,0,0.3);" @click="onInventoryItemClosed">
      <div style="width: 90%; height: 90%; background: white; border-radius: 10px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" @click.stop="dummy">
        <inventory-item-view
          :item="inventoryItemView.item"
          :product="inventoryItemView.product"
          :merchants="merchants"
          :vendors="vendors"
          :suppliers="suppliers"
          :on-updated="onInventoryItemUpdated"
          :on-product-updated="onInventoryItemProductUpdated"
          :on-reorder="onOrderChanged"
          :on-close="onInventoryItemClosed"></inventory-item-view>
      </div>
    </div>
    <inventory-item-form v-if="inventoryItemForm !== false"
                         :suppliers="suppliers"
                         :vendors="vendors"
                         :item="inventoryItemForm.item"
                         :product="inventoryItemForm.product"
                         :on-close="onInventoryItemFormClosed"
                         :on-created="onInventoryCreated">

    </inventory-item-form>
    <transition name="slideup">
    <div v-if="selectorView !== false" style="width: 100%; height: 100%; z-index: 3; position: fixed; top: 0; left: 0; background: rgba(0,0,0,0.3);" @click="selectorView = false">
      <div style="width: 600px; max-height: 80%; position: absolute; left: 50%; top: 50%; background: white; transform: translate(-50%, -50%); padding: 20px; border-radius: 20px;">
        <div class="container">
          <div class="row">
            <div class="col-12" style="line-height: 30px; font-size: 20px;">
              {{selectorView.title}}
            </div>
            <div class="col-12" style="margin-top: 30px; font-size: 15px;" v-html="selectorView.message">

            </div>

          </div>
          <div class="row" style="margin-top: 30px;">
            <div class="col-5">
              <div class="kh-btn kh-9 form-control" style="height: 60px;" @click="selectorView.negativeButton.onClicked(false)">{{selectorView.negativeButton.title}}</div>
            </div>


            <div class="col-2">
            </div>
            <div class="col-5">
              <button class="kh-btn kh-4 form-control" style="height: 60px;" @click="selectorView.positiveButton.onClicked(true)">{{selectorView.positiveButton.title}}</button>
            </div>
          </div>
        </div>

        <div class="popup-close-btn"
          @click="selectorView = false;">
          <span ><i class="fas fa-times" style="color: black;"></i></span>

        </div>
      </div>
    </div>
    </transition>
    <transition name="slideup">
      <product-mid-stock-view
        v-if="productPendingMidstockView !== false"
        :on-close="closeProductPendingMidstockView"
        :product="productPendingMidstockView.product"/>
    </transition>
<!--    <div class="manual-button" style="bottom: 20px; right: 40px; background: #000;" v-on:click="openManual">-->
<!--      <i class="fas fa-question-circle"></i>-->
<!--    </div>-->
    <div class="spinner-container" v-if="isLoading">
      <div class="spinnermedium">
        <span class="bgtopl"><span class="highlighttopl"></span></span>
        <span class="bgtopr"><span class="highlighttopr"></span></span>
        <span class="bottomrow">
          <span class="bgbtml"><span class="highlightbtml"></span></span>
          <span class="bgbtmr"><span class="highlightbtmr"></span></span>
        </span>
      </div>
    </div>
    <v-dialog width="500"/>
  </div>
</template>

<script>
import {
  getCategories,
  updateProductItem,
  updateCategoryItem,
  getProductsByCategory,
  getCategoryById,
  getProductById,
  getProductStock,
  addStock,
  updateProductStock,
  updateProductItems,
  updateCategoryItems,
  getProductStockListByState,
  getProductStockListByStateRange,
  getProductStockListByStateAndTimeRange,
  deleteProduct,
  deleteCategory,
  getProductSoldStockListByStateAndTimeRange,
  getProductInStockListByStateAndTimeRange,
  getNewProduct,
  updateProductMetaItem,
  getNewStock,
  stockQuery,
  getProductReport,
  updateProductBulk,
  searchAllProducts,
  updateProductMetaItems,
  getProductListReport,
  submitStockUnitTypeChange,
  getProductFullStockReport,
  getCategoryProductsFullStockReport,
  getProductsMigrationFullStockReport,
  getAllProductsMigrationFullStockReport,
  getProductInventories,
  createNewInventoryItem,
  getLowStockProduct,
  getEndingStockProduct,
  getChildProductListReport,
  calculateEndingStockProduct,
  markProductSupplierOrdered,
  getProductsStockStatusReportExcel,
  getProductItemById,
  changeInventoriesOrders, getNoMarginTaggedProduct
} from '../api/product'
import {
  millisToDate,
  millisToReadable,
  getStockStateString,
  getStockTypeString,
  printLabel,
  showDialog,
  getDateString,
  getDayStart,
  getDayEnd, setLastPage, timeToLocaleDateShort, getTodayDate, timeToLocaleDateYear
} from '../api/utils'
    import {getVendors} from "../api/vendors";
import {getUserByToken, sendEmail} from "../api/user";
    import {getMetasByType} from '../api/meta'
    import AWS from 'aws-sdk';
    import VueBarcode from 'vue-barcode';
    import InputTag from 'vue-input-tag'
    import ImageInput from "./ImageInput";
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    import draggable from 'vuedraggable'

    import * as firebase from "firebase/app";
    import "firebase/auth";
    import "firebase/storage";
    import {getMerchants} from "../api/merchant";
  import {createNewOrder, newChildOrder, placeMerchantOrder} from "../api/order";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import FileDownload from "js-file-download";
  import InventoryItemView from "./ItemView/InventoryItemView.vue";
  import InventoryItemForm from "./ItemView/InventoryItemForm.vue";
  import ProductTrendView from "./ItemView/ProductTrendView.vue";
  import ProductMidStockView from "./ItemView/ProductMidStockView.vue";

    export default {
        name: "Products",
        data() {
            return {
              user: false,
                merchants:[],
                currentCatIndex:-1,
                currentCatItem: false,
                searchWord:'',
                currentHighCatItem: false,
                selectedProductIndex: -1,
                categories:[],
                products: [],

                editCategoryItem: false,
                editProductItem: false,
                currentProductItem: false,
                detailedProductItem: false,
                currentProductStock:[],
                editStockItem: false,
                stockListToSubmit: [],
                printItems:[],
                isLoading:false,
                stockView: false,
                searchFilter: {
                    from:'',
                    to:'',
                },
                orderTypeOptions:[],
                newOptionTitle:'',
                email:{
                    subject:'',
                    content:'',
                },
                stockFilter:{
                  from:'',
                  to:'',

                },
                orderType:'kokoro',
                orderTypes:['kokoro', 'vendor', 'all'],
                searchType:'active',
                searchTypes:[
                  'active', 'inactive', 'all'
                ],
                stockDateRange:null,
                stockType:'all',
                stocks:[],
                vendors:[],
                suppliers:[],
                categoryOrderable:false,
                productOrderable: false,
                orderMode:false,
                orderItem: false,
                state: {
                  tickets: [{name: "test"}],
                  headers: ["Test header"]
                },
                parentSearchWord:'',
                parentSearchList:[],
                lastQuery:'',
                stockUnitChangeForm:false,
                inventoryItemView: false,

                inventoryItemForm: false,
              productDataView: false,
              selectorView:false,
              sortType:1,
              stockViewType:'inventories',
              today: getTodayDate(),
              metaFilter:'all',
              productPendingMidstockView: false,
            }
        },
        components: {
            'barcode': VueBarcode,
            InputTag,
            ImageInput,
            'multiselect': Multiselect,
            draggable,
            DatePicker,
            InventoryItemView,
          InventoryItemForm,
          ProductTrendView,
          ProductMidStockView,
        },

        created() {
          setLastPage(this.$route.path);
            // this.getProductOptions();



        },
        mounted() {
            let to = new Date();
            let from = to.getTime() - (30 * 1000 * 60 * 60 * 24);

            this.$data.searchFilter.from = millisToDate(from, '-');
            this.$data.searchFilter.to = millisToDate(to.getTime(), '-');
            console.log(this.$data.searchFilter);
            this.onLoaded();
        },
        computed: {



        },
        methods: {

          dateText:timeToLocaleDateShort,
          onLoaded: function() {
            let self = this;
            getUserByToken()
              .then(function(data) {
                self.$data.user = data;
                self.getMerchantList();
                self.getCategoryList();
                self.getVendorList();
              })
              .catch(function(err) {

              })
          },
          openProductMidstockView: function(product) {
            if(this.$data.stockView.midStockQuantity === 0) {
              return;
            }
            this.$data.productPendingMidstockView = {
              product: product,
            };
          },
          closeProductPendingMidstockView: function() {
            this.$data.productPendingMidstockView = false;
          },
          onBooleanSelectorSelected: function(value) {

            if(this.$data.selectorView === false) {
              return;
            }

            console.log("clicked " + value + " for field " + this.$data.selectorView.field);
            for(let i = 0 ;  i < this.$data.products.length ; i++) {
              if(this.$data.products[i].id === this.$data.selectorView.product.id) {
                if(this.$data.products[i][this.$data.selectorView.field] != value) {
                  this.$data.products[i][this.$data.selectorView.field] = value;
                  console.log(this.$data.selectorView.field +  " value updated to " + this.$data.products[i][this.$data.selectorView.field]);
                  updateProductItem(this.$data.products[i])
                    .then(function(data) {
                      if(data.success == false) {
                        window.alert("Failed to update " + data.message);
                      }
                    })
                    .catch(function(err) {
                      let msg = "Error happened " + err;
                      if(err.response != undefined) {
                        msg += " " + err.response;
                      }
                      window.alert(msg);
                    })
                  break;
                }

              }
            }
            this.$data.selectorView = false;

          },
          showBooleanSelectorView: function(product, field) {
            let msg = '';
            if(field === 'available') {
              msg = "Please select the availability of " + product.title;
            }
            this.$data.selectorView = {
              title: product.title,
              product:product,
              message:msg,
              field:field,
              negativeButton: {
                title: 'Not Available',
                onClicked: this.onBooleanSelectorSelected
              },
              positiveButton: {
                title: 'Available',
                onClicked: this.onBooleanSelectorSelected
              }
            }
          },
          onInventoryItemUpdated: function(item) {
            if(this.$data.stockView === false) {
              return;
            }

            if(this.$data.stockView.inventories !== null && this.$data.stockView.inventories.length > 0) {
              for(let i = 0 ; i < this.$data.stockView.inventories.length ; i++) {
                if(this.$data.stockView.inventories[i].id === item.id) {
                  if(item.active === false) {
                    this.$data.stockView.inventories.splice(i, 1);
                    this.$data.stockView.inactiveInventories.push(item);
                  } else {
                    this.$data.stockView.inventories.splice(i, 1, item);
                  }
                  return;
                }
              }
            }

            for(let i = 0 ; i < this.$data.stockView.inactiveInventories.length ; i++) {
              if(this.$data.stockView.inactiveInventories[i].id === item.id) {
                if(item.active === true) {
                  this.$data.stockView.inactiveInventories.splice(i, 1);
                  break;
                }
              }
            }
            this.$data.stockView.inventories.push(item);
          },


          changeStockViewType: function(mode) {
            if(this.$data.stockViewType === mode) {
              return;
            }
            this.$data.stockViewType = mode;
          },
          onInventoryItemFormClosed: function() {
            this.$data.inventoryItemForm = false;
          },
          openInventoryItemFormView: function(product) {
            this.$data.inventoryItemForm = {
              product:product,
              item:createNewInventoryItem(product),
            }
          },
          onInventoryCreated: function(item) {
            if(this.$data.stockView !== false) {
              this.$data.stockView.inventories.push(item);
            }
            if(this.$data.stockView !== false && this.$data.stockView.product.id === item.productId) {
              this.getStockList(this.$data.stockView.product.id);
            }
            let self = this;
            getProductItemById(this.$data.stockView.product.id)
              .then(function(data) {
                if(data.success === true) {
                  for(let i = 0 ; i < self.$data.products.length ; i++) {
                    if(self.$data.products[i].id === data.item.id) {
                      self.$data.products.splice(i, 1, data.item);
                      return;
                    }
                  }
                }
              })
          },
          refreshProductItem: function(id) {
            let self = this;
            getProductItemById(id)
              .then(function(data) {
                if(data.success === true) {
                  for(let i = 0 ; i < self.$data.products.length ; i++) {
                    if(self.$data.products[i].id === data.item.id) {
                      self.$data.products.splice(i, 1, data.item);
                      return;
                    }
                  }
                } else {
                  showDialog(data.message, "Failed to refresh product information");
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response !== undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })
          },
          onInventoryItemClosed: function() {
            this.refreshProductItem(this.$data.inventoryItemView.product.id);
            this.$data.inventoryItemView = false;

          },
          onOrderChanged: function() {

            let self = this;
            changeInventoriesOrders(this.$data.stockView.product.id, this.$data.stockView.inventories)
              .then(function(data) {
                if(data.success === true) {
                  self.$data.stockView.inventories = data.inventories;
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response !== undefined) {
                  msg += ' (' + err.response + ' )';
                }
                showDialog(msg, "ERROR");
              })
          },
          openInventoryItemView: function(product, item) {
            this.$data.inventoryItemView = {
              product: product,
              item: item
            };
          },
          onInventoryItemProductUpdated: function(product) {
            if(this.$data.inventoryItemView !== false && this.$data.inventoryItemView.product.id === product.id) {
              this.$data.inventoryItemView.product = product;
            }
            for(let i = 0 ;i < this.$data.products.length ; i++) {
              if(this.$data.products[i].id === product.id) {
                this.$data.products.splice(i, 1, product);
              }
            }
          },
          setStockUnitChangeForm: function(stock) {
            let form = {
              id: stock.id,
              weight:0.00,
              value:parseFloat((stock.value/100.0).toFixed(2)),
              product:false,
              keepValue:false,
            }

            for(let i = 0 ; i < this.$data.products.length ; i++) {
              if(this.$data.products[i].id === stock.productId) {
                form.product = this.$data.products[i];
              }
            }
            this.$data.stockUnitChangeForm = form;
            this.$data.editStockItem = false;
          },
          submitStockUnitChange: function() {
            if(this.$data.stockUnitChangeForm.id === 0) {
              showDialog("Something went wrong. Please reopen the form and try again");
              return;
            }
            if(this.$data.stockUnitChangeForm.weight === 0) {
              showDialog("Please enter total weight");
              return;
            }
            if(this.$data.stockUnitChangeForm.value === 0) {
              showDialog("Please enter total value");
              return;
            }
            let self = this;
            let weight = parseInt(parseFloat(this.$data.stockUnitChangeForm.weight)*100);
            let value = parseInt(parseFloat(this.$data.stockUnitChangeForm.value)*100);
            submitStockUnitTypeChange(this.$data.stockUnitChangeForm.id, weight, value)
              .then(function(data) {
                if(data.success === true) {

                  self.$data.stockUnitChangeForm = false;
                  self.getStockList();
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response !== undefined) {
                  msg += ' (' + err.response + ' )';
                }
                showDialog(msg, "ERROR");
              })
          },
          checkPriceChange: function() {
            if(this.$data.editProductItem.id === 0) {
              return;
            }

            let self = this;
            let changeRate = (parseFloat(this.$data.editProductItem.priceFloat) - this.$data.editProductItem.prevPrice)/this.$data.editProductItem.prevPrice*100;
            let message = '<span style="font-weight: bold; font-size: 1.3rem">' + this.$data.editProductItem.prevPrice.toFixed(2) +  " -> " + parseFloat(this.$data.editProductItem.priceFloat).toFixed(2) + '</span>';
            message += '<br/><span style="color:red; font-weight:bold;">' + changeRate.toFixed(2) + "% Change </span>";
            this.$modal.show('dialog',{
              title: 'Changing price',
              text: message,
              buttons:[
                {
                  title:'No',
                  handler:() => {
                    this.$data.editProductItem.priceFloat = this.$data.editProductItem.prevPrice;
                    self.$modal.hide('dialog');
                  }
                },
                {
                  title:'Yes correct',
                  handler:() => {
                    self.$modal.hide('dialog');
                  }
                }
              ]
            })
          },
          generateProductBarcode: function(product) {
            // If barcode is not available
            // Generate 4700 + [productId] + [000000000]

            if(product.barCode !== '' || product.barCode.length > 0) {
              return product.barCode;
            }
            if(product.productBarCode !== '' || product.productBarCode.length > 0) {
              return product.productBarCode;
            }
            return '4700' + this.zeroPad(product.id, 8) + this.zeroPad(0, 8)
          },
            showModal: function(title, message) {
                console.log("show modal " + title  + " : " + message);
                this.$modal.show('dialog',{
                    title: title,
                    text: message,
                    buttons:[
                        {title:'Close'}
                    ]
                })
                return;
            },
            zeroPad: function(num, numZeros) {
                var n = Math.abs(num);
                var zeros = Math.max(0, numZeros - Math.floor(n).toString().length );
                var zeroString = Math.pow(10,zeros).toString().substr(1);
                if( num < 0 ) {
                    zeroString = '-' + zeroString;
                }

                return zeroString+n;
            },
            getVendorList: function() {
              let self = this;
              getVendors('vendor')
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.vendors = data.item;
                  }
                  self.getSupplierList();
                })
                .catch(function(err) {

                })
            },
            getSupplierList: function() {
              let self = this;
              getVendors('supplier')
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.suppliers = data.item;
                  }
                })
                .catch(function(err) {

                })
            },
            getVendorName: function(id) {
              if(id == 0) {
                return'';
              }
              if(this.$data.vendors.length == 0) {
                return ''
              }
              for(let i = 0 ; i < this.$data.vendors.length ;i++ ) {
                if(this.$data.vendors[i].id == id) {
                  return this.$data.vendors[i].title;
                }
              }
              if(this.$data.suppliers.length == 0) {
                return '';
              }
              for(let i = 0 ; i < this.$data.suppliers.length ;i++ ) {
                if(this.$data.suppliers[i].id == id) {
                  return this.$data.suppliers[i].title;
                }
              }
              return '? ' + id;
            },
            getMerchantList: function() {
                let self = this;
                getMerchants()
                .then(function(data) {
                    if(data.success == true) {
                        self.$data.merchants = data.item;
                    }
                })
                .catch(function(err) {
                  console.log("err at getting merchants");
                  console.log(err);
                  if(err.response !== undefined) {
                    console.log(err.response);
                  }
                })
            },
          getMerchantType: function(id) {
            if(id === 0 || this.$data.merchants.length === 0) {
              return ''
            }
            for(let i = 0 ; i < this.$data.merchants.length ;i++ ) {
              if(this.$data.merchants[i].id === id) {
                return this.$data.merchants[i].type;
              }
            }
            return '? ' + id;
          },
            getMerchantName: function(id) {
                if(id === 0 || this.$data.merchants.length === 0) {
                    return ''
                }
                for(let i = 0 ; i < this.$data.merchants.length ;i++ ) {
                  if(this.$data.merchants[i].id === id) {
                    return this.$data.merchants[i].title;
                  }
                }
                return '? ' + id;
            },
            getCategoryList: function() {
                let self = this;

                getCategories()
                    .then(function(data){
                        if(data.success == true) {
                            self.$data.categories = data.item;
                        }
                    })
                    .catch(function(err) {

                    })
            },
            getCategoryProducts: function(index) {
                let cid = this.$data.categories[index].id;

                let self = this;
                getProductsByCategory(cid)
                    .then(function(data){
                        if(data.success == true) {
                            console.log(data.item);
                            self.$data.categories[index].list = data.item;
                        }
                    })
                    .catch(function(err){

                    })
            },
            getProduct: function(id) {
                getProductById(id)
                    .then(function (data) {
                        if (data.success == true) {

                        }

                    })
                    .catch(function (err) {

                    })
            },
            getCategory: function(id) {
                getCategoryById(id)
                    .then(function(data){
                        if(data.success == true) {

                        }
                    })
                    .catch(function(err) {

                    })
            },
            enableFrontPage: function() {
                console.log("toggleFrontPage")
                console.log(this.$data.editCategoryItem);
                this.$data.editCategoryItem.frontPage = !(this.$data.editCategoryItem.frontPage);
                console.log("toggleFrontPage " + this.$data.editCategoryItem.frontPage);
                console.log(this.$data.editCategoryItem);
            },
            closeCategoryEdit: function() {
                this.$data.editCategoryItem = false;
            },
            deleteCategoryAsk: function() {
                let self = this;
                this.$modal.show('dialog',{
                    title: this.$data.editCategoryItem.title + " 카테고리 삭제",
                    text: "삭제하면 해당 카테고리의 모든 상품과 재고/판매 기록 모두 삭제됩니다. 삭제하시겠습니까?",
                    buttons:[
                        {
                            title:'아니요',
                            handler:() => {
                                self.$modal.hide('dialog');
                            }
                        },
                        {
                            title:"지우기",
                            handler:() => {
                                self.$modal.hide('dialog');
                                self.deleteCategoryItem(self.$data.editCategoryItem);
                            }

                        }
                    ]
                })
            },
            deleteCategoryItem: function(item) {
                let self = this;
                this.isLoading = true;
                console.log("deleetecategory " + item.id);
                deleteCategory(item.id)
                    .then(function(data) {
                        self.isLoading = false;
                        console.log("deleteCategory res");
                        console.log(data);
                        if(data.success == true) {
                            for(let i = 0 ; i < self.$data.categories.length ; i++ ) {
                                if(self.$data.categories[i].id === data.item.id) {
                                    console.log("Deleted product found from list to delete");
                                    if(self.$data.currentCatIndex >= 0 &&
                                        self.$data.categories[self.$data.currentCatIndex].id !== undefined &&
                                        self.$data.categories[i].id === self.$data.categories[self.$data.currentCatIndex].id) {
                                        console.log("Deleted product's stocks found from list to delete");
                                        self.$data.currentProductStock = [];
                                    }

                                    //delete

                                    self.$data.categories.splice(i,1);
                                    self.$data.selectedProductIndex = -1;
                                    self.$data.editCategoryItem = false;
                                    self.$data.currentCatIndex = -1;
                                    return;
                                }
                            }

                        }
                    })
                    .catch(function(err) {
                        self.isLoading = false;
                        console.log("Delete category error " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            submitCategoryEdit: function() {

                console.log("submitCategoryEdit");
                console.log(this.$data.editCategoryItem);
                // Add position if new
                if(this.$data.editCategoryItem.id == 0) {
                    this.$data.editCategoryItem.pos = this.$data.categories.length;
                }
                let positionChange = false;
                if(this.$data.editCategoryItem.parentId != this.$data.editCategoryItem.parentId.orgParentId) {
                    positionChange = true;
                }
                this.updateCategory(this.$data.editCategoryItem, positionChange);

            },
            updateCategory: function(category, refresh = false) {
                let self = this;
                console.log("update category");
                console.log(category);
                updateCategoryItem(category)
                    .then(function(data){
                        self.$data.editCategoryItem = false;
                        if(data.success == true) {

                            if(refresh) {
                                self.getCategoryList();
                                return;
                            }
                            let item = data.item;

                            if(item.parentId == 0) {
                                for (let i = 0; i < self.$data.categories.length; i++) {
                                    if (self.$data.categories[i].id == item.id) {
                                        self.$data.categories.splice(i, 1, item);
                                        return;
                                    }
                                }
                                //If not found, add to last
                                self.$data.categories.push(item);
                            } else {
                                for (let i = 0; i < self.$data.categories.length; i++) {
                                    if (self.$data.categories[i].id == item.parentId) {

                                        for(let j = 0 ; j < self.$data.categories[i].list.length ; j++) {
                                            if(self.$data.categories[i].list[j].id == item.id) {
                                                self.$data.categories[i].list.splice(j, 1, item);
                                                return;
                                            }

                                        }
                                        self.$data.categories[i].list.push(item);
                                        return;
                                    }
                                }
                            }


                        }
                    })
                    .catch(function(err){
                        self.$data.editCategoryItem = false;
                    })
            },

            showSubCategoryEdit: function(parent) {
                  this.$data.editCategoryItem = {
                      id:0,
                      parentId:parent.id,
                      orgParentId: parent.id,
                      title:'',
                  }

            },
            showCategoryEdit: function(item = null) {
                console.log("showCategoryEdit ");
                if(item == null) {
                    this.$data.editCategoryItem = {
                        id:0,
                        parentId:0,
                        orgParentId:0,
                        title:'',
                        code:'',
                    }
                } else {
                    console.log("show edit view");
                    this.$data.editCategoryItem = JSON.parse(JSON.stringify(item));
                    console.log(this.$data.editCategoryItem);
                }
            },

            getCategoryPathString: function() {

            },
            sortItemsBy: function(field) {
              console.log("sort by " + field);
              if(this.$data.products.length === 0) {
                return;
              }
              if(field === 'currentStock') {
                for(let i = 0 ; i < this.$data.products.length ; i++) {
                  if(this.$data.products[i].parentId > 0) {
                    this.$data.products[i].currentStock = -1;
                  }
                }
              }
              console.log("sorty type " + this.$data.sortType);
              let self = this;
              this.$data.products.sort(function(a, b) {
                if(a[field] < b[field]) {
                  return self.$data.sortType;
                } else if(a[field] > b[field]) {
                  return -self.$data.sortType;
                }
                return 0;
              })
              this.$data.sortType *= -1;

            },
            initialiseSearch: function() {
                if(this.$data.currentCatItem.type != undefined && this.$data.currentCatItem.type === 'searchResults') {
                  this.$data.currentCatItem = false;
                }
                this.$data.searchWord = '';

            },
            onSearchTypeChanged: function() {
                if(this.$data.lastQuery === 'search') {
                    this.search();
                } else if(this.$data.lastQuery === 'category' && this.$data.currentCatItem !== null && this.$data.currentCatItem !== false) {
                    this.openCategoryItems(this.$data.currentCatItem);
                }
            },
            search: function() {
                this.$data.lastQuery = 'search';
                if(this.$data.searchWord.length < 3) {
                  return;
                }
                this.$data.currentCatItem = false;

                let self = this;
                searchAllProducts(this.$data.searchWord, this.$data.searchType, this.$data.orderType)
                .then(function(data) {
                    if(data.success == true) {
                      self.$data.currentCatItem = {
                        id:0,
                        title:'Seach Results',
                        type:'searchResults',
                        products:[],
                      }
                      self.$data.products = data.item;
                    } else {
                      // showDialog(data.message);
                    }

                })
                .catch(function(err) {

                })
            },
          getNoMarginTaggedProducts: function() {
            let self = this;
            this.$data.currentProductItem = false;
            this.$data.currentCatItem = false;
            this.$data.selectedProductIndex = -1;
            this.$data.products = [];
            this.$data.today = getTodayDate();
            getNoMarginTaggedProduct()
              .then(function(data) {
                console.log(data);
                if(data.success === true) {
                  self.$data.currentCatItem = {
                    id:0,
                    title:'No Margin Tagged',
                    type:'No Margin',
                    products:[],
                  }

                  self.$data.products = data.item;
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response !== undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg);
              })
          },
            getLowStockProducts: function() {
              let self = this;
              this.$data.currentProductItem = false;
              this.$data.currentCatItem = false;
              this.$data.selectedProductIndex = -1;
              this.$data.products = [];
              this.$data.today = getTodayDate();
              getLowStockProduct()
                .then(function(data) {
                  console.log(data);
                  if(data.success === true) {
                    self.$data.currentCatItem = {
                      id:0,
                      title:'Low stock',
                      type:'low stock',
                      products:[],
                    }

                    self.$data.products = data.item;
                  } else {
                    showDialog(data.message);
                  }
                })
                .catch(function(err) {
                  let msg = err;
                  if(err.response !== undefined) {
                    msg += ' (' + err.response + ')';
                  }
                  showDialog(msg);
                })
            },
          getEndingStockProducts: function(days) {
            let self = this;
            this.$data.currentProductItem = false;
            this.$data.currentCatItem = false;
            this.$data.selectedProductIndex = -1;
            this.$data.products = [];
            this.$data.today = getTodayDate();
            getEndingStockProduct(days)
              .then(function(data) {
                console.log(data);
                if(data.success === true) {
                  self.$data.currentCatItem = {
                    id:0,
                    title:'Ending in ' + days + ' dyas',
                    type:'low stock',
                    products:[],
                  }
                  self.$data.products = data.item;
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response !== undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg);
              })
          },
            openCategoryItems: function(catItem) {

                // console.log("openCategoryItems " + index);
                let self = this;
                this.$data.currentProductItem = false;
                this.$data.editProductItem = false;
                this.$data.currentCatItem = catItem;
                this.$data.currentHighCatItem = false;
                for(let i = 0 ; i < this.$data.categories.length ; i++) {
                    if(this.$data.categories[i].id == this.$data.currentCatItem.parentId) {
                        this.$data.currentHighCatItem = this.$data.categories[i];
                        break;
                    }
                }
                //this.$data.currentCatIndex = index;
                this.$data.selectedProductIndex = -1;
                this.$data.products = [];
              this.$data.today = getTodayDate();
                this.$data.lastQuery = 'category';
                console.log("get category " + this.$data.currentCatItem.id);
                getProductsByCategory(this.$data.currentCatItem.id, this.$data.searchType, this.$data.orderType)
                    .then(function(data){
                        console.log("openCategoryItems");
                        console.log(data);
                        if(data.success == true) {
                            self.$data.products = data.item;
                            console.log(self.$data.products);

                        } else {
                            self.$data.products = [];
                        }
                    })
                    .catch(function(err){

                    })

            },
            toggleSoldOut: function(i) {
                this.$data.products[i].available = !this.$data.products[i].available;
                updateProductItem(this.$data.products[i])
                .then(function(data) {
                    if(data.success == false) {
                        window.alert("Failed to update " + data.message);
                    }
                })
                .catch(function(err) {
                    let msg = "Error happened " + err;
                    if(err.response != undefined) {
                        msg += " " + err.response;
                    }
                    window.alert(msg);
                })
            },
            onProductReordered: function() {
                console.log("onProductReordered");
                for(let i = 0 ; i < this.$data.products.length ; i ++) {
                    this.$data.products[i].pos = i;
                }
                //Update products
                console.log(this.$data.products);
                updateProductItems(this.$data.products)
                    .then(function(data) {
                        if(data.success == true) {
                            console.log("Product reorder success");
                        } else {
                            console.log("Product reorder failed " + data.message);
                        }
                    })
                    .catch(function(err) {
                        console.log("Product reorder error " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })

                //openCategoryItems
            },
            onSubCategoryReordered: function(index) {
                for(let i = 0 ; i < this.$data.categories[index].list.length ; i ++) {
                    this.$data.categories[index].list[i].pos = i;
                }
                updateCategoryItems(this.$data.categories[index].list)
                    .then(function(data) {
                        if(data.success == true) {

                        }
                    })
                    .catch(function(err) {

                    })
            },
            onCategoryReordered: function() {
                for(let i = 0 ; i < this.$data.categories.length ; i ++) {
                    this.$data.categories[i].pos = i;
                }
                //update categories
                updateCategoryItems(this.$data.categories)
                    .then(function(data) {
                        if(data.success == true) {

                        }
                    })
                    .catch(function(err) {

                    })
            },

            showProductEdit(item = false) {
                this.$data.stocks = [];
                this.$data.parentSearchWord = '';
                this.$data.parentSearchList = [];
                if(item === false) {
                    this.$data.currentProductItem = false;
                    this.$data.editProductItem = getNewProduct(this.$data.currentCatItem.id);
                } else {
                    console.log("showProductEdit");
                    // console.log(this.$data.products[index]);

                    //Convert tags to array for tag input
                    // if(item.tags.length > 0) {
                    //     item.tags = item.tags.split(',');
                    // } else {
                    //     item.tags = [];
                    // }
                    // if(item.metaList != undefined && item.metaList != null && item.metaList.length > 0 ) {
                      // for(let i = 0 ; i < item.metaList.length ; i++) {
                      //   if(item.metaList[i].marginRate > 0) {
                      //     item.metaList[i].marginRate = (parseFloat(item.metaList[i].marginRate)/100).toFixed(2);
                      //   }
                      //   if(item.metaList[i].marginAmount > 0) {
                      //     item.metaList[i].marginAmount = (parseFloat(item.metaList[i].marginAmount)/100).toFixed(2);
                      //   }
                      // }
                    // }
                    this.$data.editProductItem = JSON.parse(JSON.stringify(item));
                    this.$data.editProductItem.prevPrice = this.$data.editProductItem.priceFloat;

                    console.log("Edit PRdouct");
                    console.log(this.$data.editProductItem);
                    // if(this.$data.editProductItem.imageUrls.length > 0) {
                    //     this.$data.editProductItem.imageUrls = this.$data.editProductItem.imageUrls.split(',');
                    // } else {
                    //     this.$data.editProductItem.colourList = [];
                    // }


                }
            },
            dummy: function() {

            },
            productPriceUpdate: function() {
              console.log("product price update");
              if(parseFloat(this.$data.editProductItem.marginRate) > 0) {
                this.$data.editProductItem.price = (parseFloat(this.$data.editProductItem.sourcePrice) * ( (100 +  parseFloat(this.$data.editProductItem.marginRate)) / 100)) * 100;
              } else if(parseFloat(this.$data.editProductItem.marginAmount) > 0) {
                this.$data.editProductItem.price = (parseFloat(this.$data.editProductItem.sourcePrice) + parseFloat(this.$data.editProductItem.marginAmount)) * 100;
              } else {
                this.$data.editProductItem.price = parseFloat(this.$data.editProductItem.sourcePrice) * 100;
              }
            },
            closeProductEdit: function() {
                this.$data.editProductItem = false;
            },
            askDeleteProduct: function(item) {
                let self = this;
                this.$modal.show('dialog', {
                    title:'',
                    text: item.title + " 지우시겠습니까?",
                    buttons:[
                        {
                            title:'No',
                            handler:()=>{
                                self.$modal.hide('dialog');
                            }
                        },
                        {
                            title:'지우기',
                            handler:()=>{
                                self.$modal.hide('dialog');
                                self.deleteProductItem(item);
                            }
                        }
                    ]
                })
            },

            deleteProductItem: function(item) {
                let self = this;
                this.isLoading = true;
                deleteProduct(item.id)
                    .then(function(data) {
                        self.isLoading = false;
                        if(data.success == true) {
                            self.$data.editProductItem = false;
                            for(let i = 0 ; i < self.$data.products.length ; i++ ) {
                                if(self.$data.products[i].id === data.item.id) {
                                    self.$data.products.splice(i, 1);
                                    return;
                                }
                            }

                        } else {
                          showDialog(data.message);
                        }
                    })
                    .catch(function(err) {
                        self.isLoading = false;
                        console.log("Delete product error " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            toggleBoolean: function(key) {
                if(this.$data.editProductItem == false) {
                  return;
                }
                if(this.$data.editProductItem.deleted === true) {
                  return;
                }
                this.$data.editProductItem[key] = !this.$data.editProductItem[key];
            },

            setVariablePrice: function(type) {
              let msg = this.$data.editProductItem.title + " is currently ";
              if(type === true) {
                msg += "weight based price (price per kg)";
              } else {
                msg += "quantity based normal price (like most product)";
              }
              msg += ". Are you sure to change pricing type?<br/>Please select weight based pricing or normal pricing.";

              this.$data.selectorView = {
                title: this.$data.editProductItem.title,
                product:this.$data.editProductItem,
                message:msg,
                field:'',
                negativeButton: {
                  title: 'Weight Based',
                  onClicked: this.setVariablePriceEnabled
                },
                positiveButton: {
                  title: 'Normal',
                  onClicked: this.setVariablePriceDisabled
                }
              }
            },
          setVariablePriceEnabled: function(type) {
              this.$data.editProductItem.useVariablePrice = true;

            this.$data.selectorView =false;
            },
          setVariablePriceDisabled: function(type) {
            this.$data.editProductItem.useVariablePrice = false;
            this.$data.selectorView =false;
          },
          getMerchantWithTag: function(tag) {


            let list = [];
            for(let i = 0 ; i < this.$data.merchants.length ; i++) {
              if(this.$data.merchants[i].tags !== null && this.$data.merchants[i].tags.length > 0) {
                for(let t = 0 ; t < this.$data.merchants[i].tags.length ; t++) {
                  if(this.$data.merchants[i].tags[t] === tag) {
                    list.push(this.$data.merchants[i].title);
                    break;
                  }
                }
              }
            }

            if(list.length > 0) {
              return list.join(', ');
            }
            return 'None'
          },

            updateProduct: function() {
                let self = this;
                console.log("updateProduct");
                console.log(this.$data.editProductItem);
                if(this.$data.editProductItem.title.length == 0) {
                    showDialog("품명을 입력해주세요");
                    return;
                }
                // if(this.$data.editProductItem.brand.length == 0) {
                //     this.showModal("ERROR", "브랜드 입력해주세요");
                //     return;
                // }
                if(this.$data.editProductItem.priceFloat.length == 0) {
                    showDialog("Please enter price");
                    return;
                }
                this.$data.editProductItem.price = Math.round(parseFloat(this.$data.editProductItem.priceFloat)*100);

                if(this.$data.editProductItem.stockType !== 'stock' && this.$data.editProductItem.stockType !== 'nonStock') {
                  showDialog("재고종류를 선택해주세요");
                  return;
                }

                if(this.$data.editProductItem.weightFloat !== null && this.$data.editProductItem.weightFloat !== '') {
                  this.$data.editProductItem.weight = Math.round(parseFloat(this.$data.editProductItem.weightFloat) * 100);
                } else {
                  this.$data.editProductItem.weight = 0;
                }
                this.$data.editProductItem.taxRate = parseInt(this.$data.editProductItem.taxRate);
                if(this.$data.editProductItem.taxRate !== 0 && this.$data.editProductItem.taxRate !== 2000) {
                  showDialog("VAT는 0% 또는 20%만 가능합니다. "+ this.$data.editProductItem.taxRate);
                  return;
                }

                // this.productPriceUpdate();
                console.log("update product");
                console.log(this.$data.editProductItem);
                let item = this.$data.editProductItem;

                // console.log("SP " + item.sourcePrice*100 + " MR " + item.marginRate*100 + " MA:" + item.marginAmount*100);
                // item.sourcePrice = parseInt(parseFloat(item.sourcePrice).toFixed(2).replace(".", ""));
                // item.marginRate = parseInt(parseFloat(item.marginRate).toFixed(2).replace(".", ""));
                // item.marginAmount = parseInt(parseFloat(item.marginAmount).toFixed(2).replace(".", ""));
                // item.weight = parseInt(parseFloat(item.weight).toFixed(2).replace(".", ""));
                console.log("After conversion SP " + item.sourcePrice + " MR " + item.marginRate + " MA:" + item.marginAmount);
                let productToUpdate = JSON.parse(JSON.stringify(this.$data.editProductItem));
                console.log(productToUpdate);
                productToUpdate.metaList = [];
                updateProductItem(productToUpdate)
                    .then(function(data){
                        // console.log("updateProductItem");
                        console.log(data);
                        self.$data.editProductItem = false;
                        if(data.success == true) {
                            for(let i = 0 ; i < self.$data.products.length ; i++) {
                                if(self.$data.products[i].id == data.item.id) {
                                  self.$data.products.splice(i, 1, data.item);
                                  // self.openProductItem(self.$data.products[i], true);
                                  return;
                                }
                            }
                            // data.item.price = (data.item.price/100).toFixed(2);
                            if(self.$data.currentCatItem.id == data.item.categoryId) {
                                self.$data.products.push(data.item);
                                // self.openProductItem(self.$data.products[self.$data.products.length - 1], true)
                            } else {
                                self.$data.currentProductItem = false;
                            }

                        }
                    })
                    .catch(function(err){
                        console.log(err);
                        console.log(err.response);
                    })
            },
            cancelParentSearch: function() {
              this.$data.parentSearchWord = '';
              this.$data.parentSearchList = [];
            },
            onParentSearch: function() {
              if(this.$data.parentSearchWord.length < 3) {
                this.$data.parentSearchList = [];
                return;
              }
              let self = this;
              searchAllProducts(this.$data.parentSearchWord, 'active')
              .then(function(data) {
                if(data.success) {
                  self.$data.parentSearchList = data.item;
                }
              })
              .catch(function(err) {

              })
            },
            onParentSelected: function(item) {
              this.$data.editProductItem.parent = JSON.parse(JSON.stringify(item));
              this.$data.editProductItem.parentId = item.id;
              this.cancelParentSearch();
            },
            openProductItem: function(item, updateExisting = false) {
              if(this.$data.user === false || this.$data.user.manageProduct === false) {
                showDialog("You do not have permission to edit product");
                return;
              }
                console.log("open product item " + updateExisting);
                this.$data.parentSearchWord = '';
                this.$data.parentSearchList = [];
                if(this.$data.orderMode == true) {
                  this.addChildOrderItem(item);
                  return;
                }
                let self = this;
                if(updateExisting == false) {
                  this.$data.editProductItem = false;

                  this.$data.newOptionTitle = '';
                  this.$data.stocks = [];
                }
                getProductById(item.id)
                .then(function(data) {
                    if(data.success == true) {
                        self.setCurrentProduct(data.item);
                    } else {
                      showDialog(data.message);
                    }
                })
                .catch(function(err) {
                  console.log(err);
                  let msg = err;
                  if(err.response !== undefined) {
                    console.log(err.response);
                    msg += ' (' + err.response + ')';

                  }
                  showDialog(msg, "ERROR");
                })

                //this.getProductStockInItems();
            },
            isVendorSelected: function(vendor) {
              if(this.$data.editProductItem == false) {
                return false;
              }
              for(let i = 0 ; i < this.$data.editProductItem.vendors.length ; i++) {
                if(this.$data.editProductItem.vendors[i].id == vendor.id) {
                  return true;
                }
              }
              return false;
            },
            removeVendor: function(vendor) {
              if(this.$data.editProductItem == false) {
                return;
              }

              for(let i = 0 ; i < this.$data.editProductItem.vendors.length ; i++) {
                if(this.$data.editProductItem.vendors[i].id == vendor.id) {
                  this.$data.editProductItem.vendors.splice(i, 1);
                  return;
                }
              }
            },
            vendorSelected: function(vendor) {
              if(this.$data.editProductItem == false) {
                return;
              }

              for(let i = 0 ; i < this.$data.editProductItem.vendors.length ; i++) {
                if(this.$data.editProductItem.vendors[i].id == vendor.id) {
                  return;
                }
              }

              this.$data.editProductItem.vendors.push(JSON.parse(JSON.stringify(vendor)));


            },


            isSupplierSelected: function(supplier) {
              if(this.$data.editProductItem == false) {
                return false;
              }
              for(let i = 0 ; i < this.$data.editProductItem.suppliers.length ; i++) {
                if(this.$data.editProductItem.suppliers[i].id == supplier.id) {
                  return true;
                }
              }
              return false;
            },
            removeSupplier: function(supplier) {
              if(this.$data.editProductItem == false) {
                return;
              }

              for(let i = 0 ; i < this.$data.editProductItem.suppliers.length ; i++) {
                if(this.$data.editProductItem.suppliers[i].id == supplier.id) {
                  this.$data.editProductItem.suppliers.splice(i, 1);
                  return;
                }
              }
            },
            supplierSelected: function(supplier) {
              if(this.$data.editProductItem == false) {
                return;
              }

              for(let i = 0 ; i < this.$data.editProductItem.suppliers.length ; i++) {
                if(this.$data.editProductItem.suppliers[i].id == supplier.id) {
                  return;
                }
              }

              this.$data.editProductItem.suppliers.push(JSON.parse(JSON.stringify(supplier)));


            },

            setCurrentProduct: function(item) {
                this.$data.editProductItem = false;

                this.$data.editProductItem = JSON.parse(JSON.stringify(item));

                this.$data.editProductItem.prevPrice = this.$data.editProductItem.priceFloat;

            },
            getCurrentProductStockList: function() {
              this.$data.stocks = [];
              let query = "productId=" + this.$data.editProductItem.id;
              query += "&timeFrom=" + getDayStart(this.$data.stockFilter.from);
              query += "&timeTo=" + getDayEnd(this.$data.stockFilter.to);

              let self = this;
              console.log(query);
              stockQuery(query)
              .then(function(data) {
                if(data.success == true) {
                  console.log("stock list");
                  console.log(data.list)
                  self.$data.stocks = data.list;
                } else {
                  console.log("")
                }
              })
              .catch(function(err) {

              })

            },
          getCurrentProductStockStatus: function() {
            let productIds = [];
            for(let i = 0 ; i < this.$data.products.length ; i++) {
              if(this.$data.products[i].parentId === 0) {
                productIds.push(this.$data.products[i].id);
              }
            }

            if(productIds.length === 0) {
              return;
            }
            const FileDownload = require('js-file-download');

            let date = millisToReadable(new Date().getTime());
            let fileName = 'Products-current-stock-status-' + date + '.xlsx';
            let form = {
              productIds: productIds,
            }
            getProductsStockStatusReportExcel(form)
              .then(function(response) {
                FileDownload(response.data, fileName);
              })
              .catch(function(err) {

              })

          },
            changeAllMetas: function(available) {
              if(this.$data.editProductItem == false) {
                return;
              }
              if(this.$data.editProductItem.deleted === true) {
                return;
              }
              let listToUpdate = [];
              for(let i = 0 ; i < this.$data.editProductItem.metaList.length ; i++) {
                if(this.$data.metaFilter === 'all' || this.$data.metaFilter === this.$data.editProductItem.metaList[i].merchant.type) {
                  this.$data.editProductItem.metaList[i].available = available;
                  listToUpdate.push(this.$data.editProductItem.metaList[i]);
                }
              }

              let self = this;
              updateProductMetaItems(listToUpdate)
              .then(function(data) {
                if(data.success) {
                  console.log("Updated");
                  // self.$data.editProductItem.metaList = data.item;
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })

            },
          setMerchantAvailability: function(index) {
            let msg = '<b>' + this.getMerchantName(this.$data.editProductItem.metaList[index].merchantId) + "</b><br/> Set to show or hide?";

            msg += '<br/>Currently ';
            if(this.$data.editProductItem.metaList[index].available === true) {
              msg += 'showing';
            } else {
              msg += ' hiding';
            }

            let self = this;
            this.$data.selectorView = {
              title: this.$data.editProductItem.title + ' for ' + this.getMerchantName(this.$data.editProductItem.metaList[index].merchantId),
              product:this.$data.editProductItem,
              message:msg,
              field:'',
              negativeButton: {
                title: 'HIDE',
                onClicked: function(){
                  self.$data.selectorView = false;
                  if(self.$data.editProductItem.metaList[index].available === false) {
                    return;
                  }
                  self.$data.editProductItem.metaList[index].available = false;
                  self.updateMerchantMeta(index);
                }
              },
              positiveButton: {
                title: 'SHOW',
                onClicked: function() {
                  self.$data.selectorView = false;
                  if(self.$data.editProductItem.metaList[index].available === true) {
                    return;
                  }
                  self.$data.editProductItem.metaList[index].available = true;
                  self.updateMerchantMeta(index);
                }
              }
            }
          },

            toggleMerchantAvailable: function(index) {
              if(this.$data.editProductItem === false) {
                  return;
              }
              if(this.$data.editProductItem.deleted === true) {
                return;
              }
              // this.$data.editProductItem.metaList[index].available = !this.$data.editProductItem.metaList[index].available;
              this.updateMerchantMeta(index);
            },

            updateMerchantMeta: function(index) {
              if(this.$data.editProductItem == false) {
                return;
              }
              let self = this;
              let replaceOnUpdate = false;
              if(this.$data.editProductItem.metaList[index].id == 0) {
                replaceOnUpdate = true;
              }
              console.log("update product meta")
              console.log(this.$data.editProductItem.metaList[index]);
              if(this.$data.editProductItem.metaList[index].marginRate === '') {
                this.$data.editProductItem.metaList[index].marginRate = 0;
              }
              let metaToUpdate = JSON.parse(JSON.stringify(this.$data.editProductItem.metaList[index]));
              // metaToUpdate.marginRate = parseInt(metaToUpdate.marginRate*100);
              // metaToUpdate.marginAmount = parseInt(metaToUpdate.marginAmount*100);
              updateProductMetaItem(metaToUpdate)
                .then(function(data) {
                    if(data.success == true) {
                      console.log("updated");
                      console.log(data.item);
                      if(replaceOnUpdate == true) {
                        // data.item.marginRate = (parseFloat(data.item.marginRate)/100).toFixed(2);
                        // data.item.marginAmount = (parseFloat(data.item.marginAmount)/100).toFixed(2);
                        self.$data.editProductItem.metaList.splice(index, 1, data.item);
                      }
                    } else {
                      showDialog("", data.message);
                    }
                })
                .catch(function(err) {
                  showDialog("ERROR", err);
                })
            },
          newStock: function(type) {
              if(this.$data.stockView == false) {
                return;
              }
              this.$data.editStockItem = getNewStock(this.$data.stockView.product.id, type, this.$data.stockView.product);


          },
          editStock: function(stockItem) {
            // stockItem.unitPrice = stockItem.unitPrice/100.0;
            stockItem.unitChangeable = false;
            for(let i = 0 ; i < this.$data.products.length ; i++) {
              if(stockItem.productId === this.$data.products[i].id) {
                stockItem.unitChangeable = stockItem.stockUnitType !== this.$data.products[i].stockUnitType?true:false;
                break;
              }
            }
            this.$data.editStockItem = JSON.parse(JSON.stringify(stockItem));
          },
          markAsSupplierOrdered: function(item) {
            let msg = 'Mark as ordered to supplier';
            let self = this;
            this.$data.selectorView = {
              title: item.title,
              product:item,
              message:msg,
              negativeButton: {
                title: 'Unmark',
                onClicked: function(){self.updateSupplierOrderedField(item, false);}
              },
              positiveButton: {
                title: 'Mark As Ordered',
                onClicked: function() {self.updateSupplierOrderedField(item, true);}
              }
            }
          },

          updateSupplierOrderedField: function(item, ordered) {

            let self = this;
            markProductSupplierOrdered(item.id, ordered)
              .then(function(data) {
                if(data.success === true) {
                  for(let i = 0 ; i < self.$data.products.length ; i++) {
                    if(self.$data.products[i].id === data.item.id) {
                      self.$data.products.splice(i, 1, data.item);
                      return;
                    }
                  }
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response !== undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })
          },
          openStockView: function(id) {
            if(this.$data.user === false || this.$data.user.manageProductStock === false) {
              showDialog("You do not have permission to view product stocks");
              return;
            }
            let self = this;
            let now = new Date().getTime();
            // this.$data.stockFilter.to = getDateString(now);
            //
            //
            // this.$data.stockFilter.from = getDateString(now, -7);
            this.$data.stocks = [];
            getProductById(id)
            .then(function(data){
              if(data.success == true) {
                data.item.sourcePrice = (data.item.sourcePrice/100).toFixed(2);
                self.$data.stockView = {
                  draggable:false,
                  product:data.item,
                  stocks:[],
                  inventories:[],
                  oldInventories:[],
                  inactiveInventories:[],
                  orderItems: [],
                  midStocks:[],
                  inventoryQuantity:0,
                  midStockQuantity:0,
                  orderQuantity:0,
                  availableQuantity:0,
                }
                self.getStockList(id);
                self.getProductInventoryList();
              }
            })



          },
          closeStockView: function() {
            this.$data.stockView = false;
          },
          getStockList: function(id) {
            if(this.$data.stockView == false || this.$data.stockView.product == undefined || this.$data.stockView.product.id != id) {
              return;
            }
            // let now = new Date().getTime();
            // this.$data.stockFilter.to = getDateString(now);
            //
            //
            // this.$data.stockFilter.from = getDateString(now, -7);

            if(this.$data.stockDateRange == null || this.$data.stockDateRange.length == 1) {
              let now = new Date().getTime();
              this.$data.stockDateRange = [];
              this.$data.stockDateRange[0] = getDateString(now, -7);
              this.$data.stockDateRange[1] = getDateString(now);



            }
            if(this.$data.stockDateRange.length !== 2) {
              return;
            }



            if(this.$data.stockDateRange[0] > this.$data.stockDateRange[1]) {
              let temp = this.$data.stockDateRange[1];
              this.$data.stockDateRange[0] = this.$data.stockDateRange[1];
              this.$data.stockDateRange[1] = temp;
            }
            let from = new Date(this.$data.stockDateRange[0]);
            from.setHours(0);
            from.setMinutes(0);
            from.setSeconds(0);
            from.setMilliseconds(0);



            let to = 0;
            if(this.$data.stockDateRange.length == 2) {
              to = new Date(this.$data.stockDateRange[1]);
              to.setHours(23);
              to.setMinutes(59);
              to.setSeconds(59);
              to.setMilliseconds(999);
            } else {
              to = new Date(this.$data.stockDateRange[0]);
              to.setHours(0);
              to.setMinutes(0);
              to.setSeconds(0);
              to.setMilliseconds(0);
            }
            this.$data.stocks = [];
            let query = "productId=" + this.$data.stockView.product.id;
            query += "&timeFrom=" + from.getTime();
            query += "&timeTo=" + to.getTime();

            if(this.$data.stockType !== 'all') {
              query += "&type=" + this.$data.stockType;
            }

            let self = this;
            console.log(query);
            this.$data.stockView.stocks = [];
            stockQuery(query)
              .then(function(data) {
                if(data.success == true) {
                  console.log("stock list");
                  console.log(data.list)
                  self.$data.stockView.stocks = data.list;
                } else {
                  console.log("")
                }
              })
              .catch(function(err) {

              })

          },
          getProductInventoryList: function() {
            if(this.$data.stockView === false || this.$data.stockView.product === undefined) {
              return;
            }
            this.$data.stockView.inventories = [];

            let self = this;
            getProductInventories(this.$data.stockView.product.id)
              .then(function(data) {
                if(data.success === true) {
                  console.log(data);

                  self.$data.stockView.inventories = data.inventories;
                  self.$data.stockView.inactiveInventories = data.inactiveInventories;
                  self.$data.stockView.oldInventories = data.oldInventories;
                  self.$data.stockView.orderItems = data.orderItems;
                  self.$data.stockView.midStocks = data.midStocks;
                  self.$data.stockView.inventoryQuantity = data.inventoryQuantity;
                  self.$data.stockView.midStockQuantity = data.midStockQuantity;
                  self.$data.stockView.orderQuantity = data.orderQuantity;
                  self.$data.stockView.availableQuantity = data.availableQuantity;
                  self.$data.stockView.inventoryWeight = data.inventoryWeight;
                  self.$data.stockView.midStockWeight = data.midStockWeight;
                  self.$data.stockView.availableWeight = data.availableWeight;

                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response !== undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR at getting product inventories");
              })
          },
          cancelStockItem: function() {
            this.$data.editStockItem = false;
          },
          calculateStockItem: function() {
            if(this.$data.editStockItem.stockUnitType !== null && this.$data.editStockItem.stockUnitType === 'kg') {
              this.$data.editStockItem.totalPrice = Math.round(this.$data.editStockItem.totalPriceFloat * 100);
              this.$data.editStockItem.unitPriceFloat = this.$data.editStockItem.totalPriceFloat / this.$data.editStockItem.diffWeightFloat;
              this.$data.editStockItem.unitPrice = Math.round(this.$data.editStockItem.unitPriceFloat * 100);
            } else {
              this.$data.editStockItem.unitPrice = Math.round(this.$data.editStockItem.unitPriceFloat * 100);
              this.$data.editStockItem.totalPrice = this.$data.editStockItem.unitPriceFloat * 100 * this.$data.editStockItem.diff;

            }
            this.$data.editStockItem.tax = Number((this.$data.editStockItem.totalPrice * this.$data.editStockItem.taxRate / 10000).toFixed(2));
            this.$data.editStockItem.finalDue = this.$data.editStockItem.totalPrice + this.$data.editStockItem.tax;
          },
          submitStockItem: function() {
            if(this.$data.editStockItem.type === '') {
              showDialog("", "Stock 분류를 선택해주세요");
              return;
            }

            if(this.$data.editStockItem.type !== 'stock_correction') {
              if(this.$data.editStockItem.stockUnitType !== null && this.$data.editStockItem.stockUnitType === 'kg') {
                if(this.$data.editStockItem.diffWeightFloat === 0) {
                  showDialog("", "중량을 입력해주세요");
                  return;
                }
              } else {
                if (this.$data.editStockItem.diff == 0) {
                  showDialog("", "수량을 입력해주세요");
                  return;
                }
              }

            }

            let self = this;
            console.log("submiteStockItem");
            console.log(this.$data.editStockItem);
            if(this.$data.editStockItem.stockUnitType !== null && this.$data.editStockItem.stockUnitType === 'kg') {
              this.$data.editStockItem.unitPrice = Math.round(this.$data.editStockItem.unitPriceFloat * 100);
              this.$data.editStockItem.totalPrice = Math.round(this.$data.editStockItem.totalPriceFloat * 100);

            }
            if(this.$data.editStockItem.type === 'stock_in' &&
              (this.$data.editStockItem.unitPrice == null || parseFloat(this.$data.editStockItem.unitPrice) <= 0)) {
              showDialog("", "단가를 입력해주세요");
              return;
            }
            if(this.$data.editStockItem.type === 'stock_in' && this.$data.editStockItem.vendorId == 0 && this.$data.editStockItem.noVendorRequired === false) {
              showDialog("", "구매처 (Vendor)를 선택해주세요.")
              return;
            }

            if(this.$data.editStockItem.type !== 'stock_correction' && this.$data.editStockItem.stockUnitType !== null && this.$data.editStockItem.stockUnitType === 'kg') {
              if(parseInt(this.$data.editStockItem.diffWeightFloat*100) === 0) {
                showDialog("Please enter the weight in kg");
                return;
              }
            }


            this.$data.editStockItem.amountWeight = Math.round(this.$data.editStockItem.amountWeightFloat*100);
            this.$data.editStockItem.diffWeight = Math.round(this.$data.editStockItem.diffWeightFloat*100);
            // this.$data.editStockItem.unitPrice = parseInt(this.$data.editStockItem.unitPrice*100);
            addStock(this.$data.editStockItem)
            .then(function(data) {
              if(data.success === true) {
                self.$data.editStockItem = false;

                let found = false;
                for(let i = 0 ; i < self.$data.stockView.stocks.length ; i++) {
                  if(self.$data.stockView.stocks[i].id === data.item.id) {
                    self.$data.stockView.stocks.splice(i, 1, data.item);
                    found = true;
                    break;
                  }
                }
                if(found === false) {
                  self.$data.stockView.stocks.unshift(data.item);
                }
                if(data.list !== undefined && data.list !== null && data.list.length > 0) {
                  for(let s = 0 ; s < data.list.length ; s++) {
                    for(let i = 0 ; i < self.$data.stockView.stocks.length ; i++) {
                      if(self.$data.stockView.stocks[i].id === data.list[s].id) {
                        self.$data.stockView.stocks.splice(i, 1, data.list[s]);

                        break;
                      }
                    }
                  }
                }
                self.refreshCurrentProductItem(data.item.productId);
              } else {
                showDialog("", "재고 업데이트 실패: " + data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ": " + err.response;
              }
              showDialog("ERROR", msg);
            })

          },
          getStockIcon: function(item) {
            if(item.type === 'stock_in') {
              return '<span style="color:green;">In <i class="fas fa-arrow-left" ></i></span>';
            } else if(item.type === 'stock_out') {
              return '<span style="color:red;">Out <i class="fas fa-arrow-right" ></i></span>';
            } else if(item.type === 'stock_correction') {
              return '<span style="color:blue;">Cor <i class="fas fa-wrench" ></i></span>';
            } else if(item.type === 'cancel_order') {
              return '<span style="color:black">Cancel <i class="fas fa-times"></i></span>';
            } else if(item.type === 'return') {
              return '<span style="color:purple">Return <i class="fas fa-undo"></i></span>';
            } else if(item.type === 'return_cancel') {
              return '<span style="color:purple">Return Cancel <i class="fas fa-wrench"></i></span>';
            } else if(item.type === 'return_to_vendor') {
              return '<span style="color:red">Vendor <i class="fas fa-undo"></i></span>';
            } else if(item.type === 'in_house_disposal') {
              return '<span style="color:red;">In House Disposal <i class="fas fa-trash"></i></span>';
            } else if(item.type === 'disposal') {
              return '<span style="color:purple;">Customer Disposal <i class="fas fa-trash"></i></span>';
            } else if(item.type === '3rd_disposal') {
              return '<span style="color:purple;">3rd Party Disposal <i class="fas fa-trash"></i></span>';
            } else if(item.type === 'in_house_disposal') {
              return '<span style="color:red;">In House Disposal <i class="fas fa-trash"></i></span>';
            } else if(item.type === 'sample') {
              return '<span style="color:purple;">Sample <i class="fas fa-gift"></i></span>';
            } else if(item.type === 'donation') {
              return '<span style="color:purple;">Sample <i class="fas fa-gift"></i></span>';
            } else if(item.type === 'internal_use') {
              return '<span style="color:purple;">Internal Use <i class="fas fa-trash"></i></span>';
            } else if(item.type === 'damaged') {
              return '<span style="color:red;">Damaged <i class="fas fa-dizzy"></i></span>';
            } else if(item.type === 'others') {
              return '<span style="color:red;">Others <i class="fas fa-question"></i></span>';
            }
            return 'Unknown';
          },
          refreshCurrentProductItem: function(pid) {
            // if(this.$data.editProductItem == false) {
            //   return;
            // }
            let self = this;
            getProductItemById(pid)
            .then(function(data) {
              if(data.success == true) {
                for(let i = 0 ; i < self.$data.products.length ; i++) {
                  if(self.$data.products[i].id == data.item.id) {
                    self.$data.products.splice(i, 1, data.item);
                    break;
                  }
                }
                // if(self.$data.editProductItem != false && self.$data.editProductItem.id == data.item.id) {
                //   self.$data.editProductItem = data.item;
                // }
              }
            })
            .catch(function(err) {

            })
          },
            addLabelItem(productId, stockId, productTitle, description, brand, price) {
                for(let i = 0 ; i < this.$data.printItems.length ; i++) {
                    if(this.$data.printItems[i].pid == productId &&
                        this.$data.printItems[i].title === productTitle &&
                        this.$data.printItems[i].brand === brand &&
                        this.$data.printItems[i].price === price &&
                        this.$data.printItems[i].description === description) {
                        this.$data.printItems[i].barcode += ",4700" + this.zeroPad(productId, 8) + this.zeroPad(stockId, 8)
                        return;
                    }
                }

                let item = {
                    barcode: "4700" + this.zeroPad(productId, 8) + this.zeroPad(stockId, 8),
                    pid: productId,
                    stockId: stockId,
                    title: productTitle,
                    description: description,
                    brand: brand,
                    price: price
                };
                this.$data.printItems.push(item);
            },
            deleteItem: function(index) {
                let self = this;
                this.$modal.show('dialog',{
                    title: "삭제",
                    text: "삭제하시겠습니까?",
                    buttons:[
                        {
                            title:'아니요',
                            handler:() => {
                                self.$modal.hide('dialog');
                            }
                        },
                        {
                            title:"지우기",
                            handler:() => {
                                self.$modal.hide('dialog');
                                self.confirmDeleteItem(index);
                            }

                        }
                    ]
                })
            },

            confirmDeleteItem: function(index) {
                this.$data.currentProductStock[index].deleted = true;
                let self = this;
                console.log("confirmDeleteItem ");
                // let item = {
                //     id: this.$data.currentProductStock[index].id,
                //     deleted: true,
                // }
                // console.log(item);
                this.updateStockItem(this.$data.currentProductStock[index]);
                // addStock(this.$data.currentProductStock[index])
                //     .then(function(data) {
                //         //self.$data.editStockItem = false;
                //         if (data.success === true) {
                //             if(data.item.deleted == true) {
                //                 self.$data.currentProductStock.splice(index, 1);
                //                 console.log("delete success");
                //                 console.log(data.item);
                //                 self.updateProductStock(data.item.productId);
                //             }
                //         }
                //     })
                //     .catch(function(err) {
                //         console.log("update stock item to delete failed " + err);
                //         if(err.response != undefined) {
                //             console.log(err.response);
                //         }
                //     })
            },

            printItem: function(index) {
                let barcode = "4700" + this.zeroPad(this.$data.products[this.$data.selectedProductIndex].id, 8)
                    + this.zeroPad(this.currentProductStock[index].id, 8);

                this.$data.isLoading = true;
                let self = this;
                printLabel(barcode,
                    this.$data.products[this.$data.selectedProductIndex].title,
                    this.currentProductStock[index].colour,
                    this.$data.products[this.$data.selectedProductIndex].brand,
                    this.$data.products[this.$data.selectedProductIndex].price.toFixed(2))
                    .then(function(data){
                        self.$data.isLoading = false;
                        if(data.success) {

                        } else {
                            console.log("Printer returned false");
                        }
                    })
                    .catch(function(err){
                        self.$data.isLoading = false;
                        console.log("PRinter err " + err);
                        if(err.response != undefined) {
                            console.log(err.response)
                        }
                    })
            },
            printLabelItems: function() {
                if(this.$data.printItems.length == 0) {
                    return;
                }

                //let barcode = "4700" + this.zeroPad(this.$data.printItems[0].pid, 8) + this.zeroPad(this.$data.printItems[0].stockId, 8);

                let self = this;
                self.$data.isLoading = true;
                printLabel(this.$data.printItems[0].barcode, this.$data.printItems[0].title, this.$data.printItems[0].description,
                    this.$data.printItems[0].brand, this.$data.printItems[0].price.toFixed(2))
                    .then(function(data){
                        self.$data.isLoading = false;
                        if(data.success) {
                            self.$data.printItems.splice(0, 1);
                            self.printLabelItems();
                        } else {
                            console.log("Printer returned false");
                        }
                    })
                    .catch(function(err){
                        self.$data.isLoading = false;
                        console.log("PRinter err " + err);
                        if(err.response != undefined) {
                            console.log(err.response)
                        }
                    })


            },

            refreshProduct(pid) {
                let self = this;
                getProductById(pid)
                    .then(function(data){
                        if(data.success === true) {
                            if(self.$data.products[self.$data.selectedProductIndex].id === data.item.id) {


                                self.$data.products.splice(self.$data.selectedProductIndex, 1, data.item);
                                return;
                            }

                            for(let i = 0 ; i < self.$data.products.length ; i++) {
                                if(self.$data.products[i].list.length > 0) {
                                    if(self.$data.products.id === data.item.id) {
                                        self.$data.products.splice(j, 1, data.item);
                                        return;
                                    }

                                }
                            }

                            console.log("Cannot find product item to update");
                        }
                    })
                    .catch(function(err){

                    })
            },

            addOptionItem: function() {
                let newItem = {
                    id:0,
                    title:'',
                    imageUrls:'',
                    parentId: this.$data.currentProductItem.id,
                }
                this.$data.currentProductItem.list.push(newItem);
            },
            newOptionItemEntered: function() {
                if(this.$data.newOptionTitle.length == 0) {
                    return;
                }
                let newItem = {
                    id:0,
                    title:this.$data.newOptionTitle,
                    imageUrls:'',
                    parentId: this.$data.currentProductItem.id,
                }
                let self = this;
                updateProductItem(newItem)
                    .then(function(data) {
                        if(data.success == true) {
                            self.$data.newOptionTitle = '';
                            self.$data.currentProductItem.list.push(data.item)
                        }
                    })
                    .catch(function(err) {

                    })
            },
            optionItemChanged: function(item) {
                updateProductItem(item)
                    .then(function(data) {

                    })
                    .catch(function(err) {

                    })
            },
            deleteOptionItem: function(item) {
                let self = this;
                deleteProduct(item.id)
                    .then(function(data) {
                        if(data.success == true) {
                            console.log("deleteOptionItem resp");
                            console.log(data);
                            for(let i = 0 ; i < self.currentProductItem.list.length ; i++) {
                                if(self.currentProductItem.list[i].id == data.item.id) {
                                    self.currentProductItem.list.splice(i, 1);
                                    return;
                                }
                            }
                        }
                    })
                    .catch(function(err) {

                    })
            },
            onImageDeleted: function(index) {
                if(index >= this.$data.editProductItem.imageUrls.length) {
                    console.log("Wrong index");
                    return;
                }
                this.$data.editProductItem.imageUrls.splice(index, 1);
            },
            onOptionItemImageSelected: function({image, index}) {
                console.log('New picture selected! ' + index);
                let id = index;
                let self = this;

                //return;
                if (image) {
                    var i = new Image();
                    i.onload = function() {
                        var imgW = i.width;
                        var imgH = i.height;

                        var proportion = 1.0;
                        if(imgH > imgW) {
                            proportion = 512/imgH;
                        } else {
                            proportion = 512/imgW;
                        }

                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');

                        // set its dimension to target size
                        canvas.width = imgW*proportion;
                        canvas.height = imgH*proportion;

                        // draw source image into the off-screen canvas:
                        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

                        // encode image to data-uri with base64 version of compressed image
                        //return canvas.toDataURL();
                        console.log(canvas);
                        var bob = canvas.toDataURL();
                        console.log('Picture loaded.');
                        console.log(bob);

                        /**
                         * Perform upload image
                         * and update db
                         */
                        self.uploadOptionImage(bob, id);
                    }
                    i.src = image;

                    // this.uploadImage(this.image);
                } else {
                    console.log('FileReader API not supported: use the <form>, Luke!')
                }
            },
            uploadOptionImage: function(image, id) {
                let d = new Date();
                let name  =  moment(d).format('YYYYMMDD-hhmmss');

                let path = id + '/' + name + '.jpg';
                //var path = this.$data.menus[index].id + '/' + name + '.jpg';
                console.log("Path: " + path + " type:");
                //return;
                AWS.config.update({
                    "accessKeyId" : "AKIAJK3BIVKNERMSV6KA",
                    "secretAccessKey" : "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",
                    "region" : "ap-northeast-2"
                });

                let block = image.split(";");
                // Get the content type of the image
                let contentType = block[0].split(":")[1];// In this case "image/gif"
                // get the real base64 content of the file
                let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

                // Convert it to a blob to upload
                let blob = this.b64toBlob(realData, contentType);

                // Create a FormData and append the file with "image" as parameter name
                //var formDataToUpload = new FormData(form);
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'beibledu',
                    Key: path,
                    ContentType: contentType,
                    Body : blob,
                    ACL: 'public-read'
                };
                //return;
                let self = this;

                // Now upload to S3
                s3.putObject(params, function(err, res){
                    if(err) {
                        //Error
                        console.log("ERROR to upload " + err);

                    } else {
                        //On success, update item
                        console.log("Success to upload" + res);
                        console.log(res);
                        for(let i = 0 ; i < self.$data.currentProductItem.list.length ; i++) {
                            if(self.$data.currentProductItem.list[i].id == id) {
                                self.$data.currentProductItem.list[i].imageUrls = "https://beibledu.s3.ap-northeast-2.amazonaws.com/" + path;
                                console.log("Now update optionItem");
                                console.log(self.$data.currentProductItem.list[i]);
                                updateProductItem(self.$data.currentProductItem.list[i])
                                    .then(function(data) {
                                        console.log("update Option Image ")
                                        console.log(data);

                                    })
                                    .catch(function(err) {
                                        console.log("update Option image erro " + err);
                                        if(err.response != undefined) {
                                            console.log(err.response);
                                        }
                                    })
                            }
                        }
                        //self.$data.editProductItem.imageUrls.push("https://borium.s3.eu-west-2.amazonaws.com/" + path)
                        /*
                                                updateProductItem(editProductItem).then(function(data) {
                                                    if(data.success == true) {
                                                        self.getProduct(data.item.id);
                                                    }
                                                }).catch(function(err){

                                                })

                        */
                    }
                });
            },
            fileBtn:function(e) {
              // e.preventDefault();
              const uploader = document.getElementById('uploader');
              //get file
              console.log("File Btn Added");
              console.log(e);
              let getFile = e.target.files[0];
              console.log("File name - " + getFile.name);
              //set storage ref
              let d = new Date();
              let name = moment(d).format('YYYYMMDD-hhmmss');
              let names = getFile.name.split('.');
              let path = 'products/' + this.$data.editProductItem.id + '-' + name + '.' + names[names.length-1];
              let storageRef = firebase.storage().ref();
              let mountainsRef = storageRef.child(path);
              let self = this;
              mountainsRef.put(getFile).on('state_changed',
                function progress(snapshot){

                  let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
                  console.log("percentage " + percentage);
                  uploader.value = percentage;
                },
                function error(err){
                  console.log(err);
                },
                function complete(){
                  console.log('complete upload https://storage.googleapis.com/kokoro-294123.appspot.com/' + path);
                  self.$data.editProductItem.imageUrls.push('https://storage.googleapis.com/kokoro-294123.appspot.com/' + path);
                  console.log(self.$data.editProductItem.imageUrls);
                }
              );
            },
            onItemImageSelected: function({image, index}) {
                console.log('New picture selected!');
                let self = this;

                //return;
                if (image) {
                    var i = new Image();
                    i.onload = function() {
                        var imgW = i.width;
                        var imgH = i.height;

                        var proportion = 1.0;
                        if(imgH > imgW) {
                            proportion = 512/imgH;
                        } else {
                            proportion = 512/imgW;
                        }

                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');

                        // set its dimension to target size
                        canvas.width = imgW*proportion;
                        canvas.height = imgH*proportion;

                        // draw source image into the off-screen canvas:
                        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

                        // encode image to data-uri with base64 version of compressed image
                        //return canvas.toDataURL();
                        console.log(canvas);
                        var bob = canvas.toDataURL();
                        console.log('Picture loaded.');
                        console.log(bob);

                        /**
                         * Perform upload image
                         * and update db
                         */
                        self.uploadImage(bob, index);
                    }
                    i.src = image;

                    // this.uploadImage(this.image);
                } else {
                    console.log('FileReader API not supported: use the <form>, Luke!')
                }
            },
            uploadImage: function(image, id) {
                let d = new Date();
                let name  =  moment(d).format('YYYYMMDD-hhmmss');

                let path = this.$data.editProductItem.id + '/' + name + '.jpg';
                //var path = this.$data.menus[index].id + '/' + name + '.jpg';
                console.log("Path: " + path + " type:");
                //return;
                AWS.config.update({
                    "accessKeyId" : "AKIAJK3BIVKNERMSV6KA",
                    "secretAccessKey" : "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",
                    "region" : "ap-northeast-2"
                });

                let block = image.split(";");
                // Get the content type of the image
                let contentType = block[0].split(":")[1];// In this case "image/gif"
                // get the real base64 content of the file
                let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

                // Convert it to a blob to upload
                let blob = this.b64toBlob(realData, contentType);

                // Create a FormData and append the file with "image" as parameter name
                //var formDataToUpload = new FormData(form);
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'beibledu',
                    Key: path,
                    ContentType: contentType,
                    Body : blob,
                    ACL: 'public-read'
                };
                //return;
                let self = this;

                // Now upload to S3
                self.$data.isLoading = true;
                s3.putObject(params, function(err, res){
                    if(err) {
                        //Error
                        self.$data.isLoading = false;
                        console.log("ERROR to upload " + err);
                        self.showModal("", "업로드 에러입니다. " + err);
                    } else {
                        self.$data.isLoading = false;
                        //On success, update item
                        console.log("Success to upload" + res);
                        console.log(res);
                        self.$data.editProductItem.imageUrls.push("https://beibledu.s3.ap-northeast-2.amazonaws.com/" + path)
                        console.log("https://beibledu.s3.ap-northeast-2.amazonaws.com/" + path);
                    }
                });
            },
            b64toBlob: function(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },
            getFirstImage: function(item) {
                if(item.imageUrls.length > 0) {
                    return item.imageUrls.split(',')[0];
                }
                return 'https://borium.s3.eu-west-2.amazonaws.com/beible/ic-book.png';
            },



            onfileselectorClick: function(refId){
                console.log("onfileselectorClick " + refId);
                this.$refs[refId][0].value = "";
                this.$refs[refId][0].click()
            },
            removeAttachment: function(li) {
                if(this.$data.editProductItem.linkUrl.length < li+1) {
                    return;
                }
              this.$data.editProductItem.linkUrl.splice(li, 1);
            },
            addFilePickedUp: function(e) {
                console.log("addFilePickedUp " );
                let self = this;
                if (e.target != undefined) {
                    if (e.target.files != undefined) {
                        let droppedFiles = e.target.files;
                        ([...droppedFiles]).forEach(file => {
                            console.log("pickedup " + file.type + ' ' + file.name);
                            self.uploadFileAWS(file, file.name, file.type);
                        })
                    }
                }
            },

            uploadFileAWS: function(file, name, type) {
                let d = new Date();
                name  =  moment(d).format('YYYYMMDD-hhmmss') + '-' + name;

                let path = this.$data.editProductItem.id + '/' + name;
                //var path = this.$data.menus[index].id + '/' + name + '.jpg';
                console.log("Path: " + path + " type:");
                //return;
                AWS.config.update({
                    "accessKeyId" : "AKIAJK3BIVKNERMSV6KA",
                    "secretAccessKey" : "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",
                    "region" : "ap-northeast-2"
                });

                // Create a FormData and append the file with "image" as parameter name
                //var formDataToUpload = new FormData(form);
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'beibledu',
                    Key: path,
                    ContentType: type,
                    Body : file,
                    ACL: 'public-read'
                };
                //return;
                let self = this;
                self.$data.isLoading = true;
                // Now upload to S3
                s3.putObject(params, function(err, res){
                    if(err) {
                        self.$data.isLoading = false;
                        //Error
                        console.log("ERROR to upload " + err);
                        self.showModal("", "업로드 에러입니다. " + err);

                    } else {
                        self.$data.isLoading = false;
                        //On success, update item
                        console.log("Success to upload" + res);
                        console.log(res);
                        self.$data.editProductItem.linkUrl.push("https://beibledu.s3.ap-northeast-2.amazonaws.com/" + path);
                    }
                });
            },
            getTimeString:millisToReadable,

            getDateString: function(date) {

              if(date === null || date.length !== 10) {
                return date;
              }
              let d = new Date(date);
              return timeToLocaleDateYear(d.getTime());
            },
            toggleOrderMode: function() {
              this.$data.editProductItem = false;
              this.$data.orderMode = true;
              if(localStorage.getItem("merchantOrder") != undefined && localStorage.getItem("merchantOrder") != null) {
                this.$data.orderItem = JSON.parse(localStorage.getItem("merchantOrder"));
              } else {
                this.$data.orderItem = createNewOrder();
              }

            },
            addChildOrderItem: function(product) {


              let found = false;
              if(this.$data.orderItem.list.length > 0) {
                for(let i = 0 ; i < this.$data.orderItem.list.length ; i++) {
                  if(this.$data.orderItem.list[i].productId == product.id) {
                    this.$data.orderItem.list[i].amount += 1;
                    this.$data.orderItem.list[i].totalPrice = this.$data.orderItem.list[i].price * this.$data.orderItem.list[i].amount;
                    this.$data.orderItem.list[i].tax = this.$data.orderItem.list[i].totalPrice * (this.$data.orderItem.list[i].taxRate / (1000 + this.$data.orderItem.list[i].taxRate));
                    this.$data.orderItem.list[i].finalDue = this.$data.orderItem.list[i].totalPrice + this.$data.orderItem.list[i].tax;
                    found = true;
                    break;
                  }
                }
              }
              if(found == false) {
                let newItem = newChildOrder(product);
                console.log("new item")
                console.log(newItem);
                this.$data.orderItem.list.push(newItem);
              }
              this.updateOrderBasket();
            },
            changeOrderAmount: function(index, diff) {
              this.$data.orderItem.list[index].amount = Number(this.$data.orderItem.list[index].amount) + diff;
              if(this.$data.orderItem.list[index].amount <= 0) {
                this.$data.orderItem.list.splice(index, 1);
              } else {
                this.$data.orderItem.list[index].totalPrice = this.$data.orderItem.list[index].price * this.$data.orderItem.list[index].amount;
                this.$data.orderItem.list[index].tax = this.$data.orderItem.list[index].totalPrice * this.$data.orderItem.list[index].taxRate / 1000;
                this.$data.orderItem.list[index].finalDue = this.$data.orderItem.list[index].totalPrice + this.$data.orderItem.list[index].tax;
              }
              this.updateOrderBasket();
            },
            deleteOrderItem: function(index) {
              this.$data.orderItem.list.splice(index, 1);
              this.updateOrderBasket();
            },
            deleteOrder: function() {
              this.deleteOrderConfirmed();
            },
            deleteOrderConfirmed: function() {
              this.$data.orderItem = false;
              this.$data.orderMode = false;
              localStorage.removeItem("merchantOrder");
            },
            calculateOrder: function() {
              if(this.$data.orderItem.list.length > 0) {
                for(let i = 0 ; i < this.$data.orderItem.list.length ; i++) {
                  this.$data.orderItem.list[i].totalPrice = this.$data.orderItem.list[i].price * this.$data.orderItem.list[i].amount;
                  this.$data.orderItem.list[i].tax = this.$data.orderItem.list[i].totalPrice * (this.$data.orderItem.list[i].taxRate / (1000 + this.$data.orderItem.list[i].taxRate));
                  this.$data.orderItem.list[i].finalDue = this.$data.orderItem.list[i].totalPrice + this.$data.orderItem.list[i].tax;

                }
              }
              this.updateOrderBasket();
            },
            closeOrderBasket: function() {
              this.$data.orderItem = false;
              this.$data.orderMode = false;
            },
            updateOrderBasket: function() {
              let totalPrice = 0;
              let taxAmount = 0;
              let totalDue = 0;
              if(this.$data.orderItem.list.length > 0) {
                for (let i = 0; i < this.$data.orderItem.list.length; i++) {
                  totalPrice += this.$data.orderItem.list[i].totalPrice;
                  taxAmount += this.$data.orderItem.list[i].tax;
                }
              }

              totalDue = totalPrice + taxAmount;

              this.$data.orderItem.totalPrice = totalPrice;
              this.$data.orderItem.tax = taxAmount;
              this.$data.orderItem.finalDue = totalDue;

              localStorage.setItem("merchantOrder", JSON.stringify(this.$data.orderItem));
            },
            submitOrderBasket: function() {
              if(this.$data.orderItem == false) {
                showDialog("No Order to submit");
                return;
              }

              if(this.$data.orderItem.merchantId == 0) {
                showDialog("Select Merchant");
                return;
              }

              if(this.$data.orderItem.deliveryDate == '' || this.$data.orderItem.deliveryDate === '0000-00-00') {
                showDialog("Select Delivery Date");
                return;
              }
              let today = new Date();
              let todayString = millisToDate(today.getTime(), '-');
              if(this.$data.orderItem.deliveryDate < todayString) {
                showDialog("Date is earlier than today");
                return;
              }
              if(this.$data.orderItem.list.length == 0) {
                showDialog("Select Merchant");
                return;
              }


              let self = this;

              placeMerchantOrder(this.$data.orderItem)
              .then(function(data) {
                if(data.success == true) {
                  showDialog("Submitted successfully");
                  self.$data.orderItem = false;
                  self.$data.orderMode = false;
                  localStorage.removeItem("merchantOrder");
                } else {
                  showDialog("Failed to submit " + data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg);
              })
            },
            downloadProductList: function() {
              let self = this;
              const FileDownload = require('js-file-download');
              getProductReport()
              .then(function(response) {
                FileDownload(response.data, "Kokoro-Product-List-report.xlsx");
              })
              .catch(function(err) {
                console.log("report error " + err);
                if(err.response != undefined) {
                  console.log(err.response);
                }
              })
            },
          downloadChildProductListExcel: function() {

            let self = this;
            const FileDownload = require('js-file-download');
            getChildProductListReport()
              .then(function(response) {
                FileDownload(response.data, "Kokoro-Child-Product-List.xlsx");
              })
              .catch(function(err) {
                console.log("report error " + err);
                if(err.response != undefined) {
                  console.log(err.response);
                }
              })
          },
            downloadProductListExcel: function() {
              let self = this;
              const FileDownload = require('js-file-download');
              getProductListReport()
                .then(function(response) {
                  FileDownload(response.data, "Kokoro-Product-List.xlsx");
                })
                .catch(function(err) {
                  console.log("report error " + err);
                  if(err.response != undefined) {
                    console.log(err.response);
                  }
                })
            },
            onFileSelectorClick: function() {
              console.log("upload clicked");
              this.$refs.file.value = "";
              this.$refs.file.click();
            },
            excelFilePickedUp(e) {
              let self = this;
              if(e.target != undefined) {
                if (e.target.files != undefined) {
                  console.log("PATH: " + e.target.files[0].name);
                  let droppedFiles = e.target.files;

                  ([...droppedFiles]).forEach(f => {
                    if(f == undefined) {
                      return;
                    }
                    var reader = new FileReader(),
                      name = f.name;

                    reader.onload = function (e) {
                      var results;
                      var data = e.target.result;


                      var fixedData = self.fixdata(data),
                        workbook = XLSX.read(btoa(fixedData), {type: 'base64'}),
                        firstSheetName = workbook.SheetNames[0],
                        worksheet = workbook.Sheets[firstSheetName];
                      self.$data.state.headers = self.get_header_row(worksheet);
                      results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                      console.log(results);
                      if(results.length < 3) {
                        window.alert("No Menu Data");
                        return;
                      }

                      let cats = [];
                      for(let i = 0 ; i < results.length ; i++) {
                        let r = results[i];

                        if(r["Name"] !== undefined) {
                          if(r["Name"] === "") {
                            continue;
                          }
                          let catTitle = "Uncategorised";
                          if(r["Category"] != undefined && r["Category"].length > 0) {
                            catTitle = r["Category"];
                          }
                          // console.log("CATEGORY " + catTitle);
                          let catIndex = -1;
                          if(cats.length > 0) {
                            for(let j = 0 ; j < cats.length ; j++) {
                              if(cats[j].title === catTitle) {
                                catIndex = j;
                                break;
                              }
                            }
                          }
                          if(catIndex == -1) {
                            let newCat = {
                              title: catTitle,
                              products:[],
                            }
                            cats.push(newCat);
                            catIndex = cats.length - 1;
                          }

                          let price = 0;
                          if(r["Price per UOM"] !== undefined && r["Price per UOM"] !== "") {
                            price = parseInt(parseFloat(r["Price per UOM"]) * 100);
                          }

                          let taxRate = 0;
                          if(r["Tax rate"] !== undefined) {
                            if(r["Tax rate"] === "Zero Rated" || r["Tax rate"] === "exempt" || r["Tax rate"] === "Exempt") {

                            } else if(r["Tax rate"] === "20% VAT") {
                              taxRate = 2000;
                            } else {
                              showDialog("Error " + i + " does not have correct tax rate")
                              return;
                            }
                          }
                          let product = {
                            title:r["Name"],
                            unit:r["UOM"],
                            unitAmount:1,
                            sourcePrice:price,
                            taxRate: taxRate,
                            vendors:[],
                            suppliers:[],
                            stockType:'stock',
                            available:true,
                          }

                          let ignore = false;

                          for(let j = 0 ; j < cats[catIndex].products.length ; j++) {
                            console.log(cats[catIndex].title + " Compare " + cats[catIndex].products[j].title + "(" +  cats[catIndex].products[j].taxRate + ") VS " + product.title + "(" + product.taxRate +")");
                            if(cats[catIndex].products[j].title === product.title) {
                              if(cats[catIndex].products[j].taxRate == 0 && product.taxRate > 0) {
                                console.log("Remove " + cats[catIndex].products[j].title + " (" + cats[catIndex].products[j].taxRate + ')');
                                cats[catIndex].products.splice(j, 1);
                                break;
                              } else if(cats[catIndex].products[j].taxRate > 0 && product.taxRate == 0) {
                                console.log("Ignore " + product.title);
                                ignore = true;
                                break;
                              } else if(cats[catIndex].products[j].taxRate == product.taxRate) {
                                console.log("Ignore " + product.title + " as the same");
                                ignore = true;
                                break;
                              }
                            } else {
                              console.log("title are not the same");
                            }
                          }
                          if(ignore == true) {
                            continue;
                          }
                          if(r["Ordering"] !== undefined && r["Ordering"] === "Non-active") {
                            product.available = false;
                            console.log(product.title + ' is set to no available');
                          }
                          if(r["Supplier"] !== undefined && r["Supplier"] !== "") {
                            let supplier = {
                              title: r["Supplier"].trim(),
                            };
                            product.vendors.push(supplier);

                          }
                          if(r["Vendor"] !== undefined && r["Vendor"] !== "") {
                            let vendors = r["Vendor"].split(",");
                            for(let i = 0 ; i < vendors.length ; i++) {
                              let vendor = {
                                title: vendors[i].trim(),
                              };
                              product.vendors.push(vendor);
                            }
                          }

                          cats[catIndex].products.push(product);




                        } else if(r["ProductId"] !== undefined) {
                          if(r["ProductId"] === "0:New") {
                            continue;
                          }
                          let catTitle = "Uncategorised";
                          if(r["Category"] != undefined && r["Category"].length > 0) {
                            catTitle = r["Category"];
                          }
                          let catIndex = -1;
                          if(cats.length > 0) {
                            for(let j = 0 ; j < cats.length ; j++) {
                              if(cats[j].title === catTitle) {
                                catIndex = j;
                                break;
                              }
                            }
                          }
                          if(catIndex == -1) {
                            let newCat = {
                              title: catTitle,
                              products:[],
                            }
                            cats.push(newCat);
                            catIndex = cats.length - 1;
                          }
                          let sourcePrice = 0;
                          if(r["Price"] !== undefined && r["Price"] !== "") {
                            sourcePrice = parseInt(parseFloat(r["Price"]) * 100);
                          }
                          let marginRate = 0;
                          if(r["Margin Rate"] !== undefined && r["Margin Rate"] !== "") {
                            marginRate = parseInt(parseFloat(r["Margin Rate"]) * 100);
                          }
                          let marginAmount = 0;
                          if(r["Margin Amount"] !== undefined && r["Margin Amount"] !== "") {
                            marginAmount = parseInt(parseFloat(r["Margin Amount"]) * 100);
                          }
                          let price = 0;
                          if(r["Sale Price"] !== undefined && r["Sale Price"] !== "") {
                            price = parseInt(parseFloat(r["Sale Price"]) * 100);
                          }
                          let taxRate = 0;
                          if(r["VAT"] !== undefined && r["VAT"] !== "") {
                            taxRate = parseInt(parseFloat(r["VAT"]) * 100);
                          }
                          let minStock = 0;
                          if(r["Min Stock"] !== undefined && r["Min Stock"] !== "") {
                            minStock = parseInt(r["Min Stock"]);
                          }
                          let weight = 0;
                          if(r["Weight"] !== undefined && r["Weight"] !== "") {
                            weight = parseInt(parseFloat(r["Weight"]) * 100);
                          }
                          let product = {
                            id:0,
                            title:r["Product"],
                            unit:r["UOM"],
                            unitAmount:1,
                            sourcePrice:sourcePrice,
                            taxRate: taxRate,
                            minStock:minStock,
                            marginRate:marginRate,
                            marginAmount:marginAmount,
                            price:price,
                            vendors:[],
                            suppliers:[],
                            stockType:r["Stock Type"],
                            available:true,
                            weight:weight,

                          }

                          if(product.marginRate == 0 && product.price > product.sourcePrice) {
                            product.marginAmount = product.price - product.sourcePrice;
                          } else if(product.sourcePrice > 0 && product.marginRate > 0) {
                            console.log(product.title + " found margin rate " + product.price + " margin " + product.marginRate + "%");
                            product.price = product.sourcePrice + (product.sourcePrice * product.marginRate / 10000);
                            console.log(product.title + " final price " + product.price);
                          }

                          if(r["ProductId"] !== "") {
                            product.id = parseInt(r["ProductId"]);
                          } else {

                          }
                          if(r["Ordering"] !== undefined && r["Ordering"] === "Non-active") {
                            product.available = false;
                            console.log(product.title + ' is set to no available');
                          }
                          if(r["Supplier"] !== undefined && r["Supplier"] !== "") {
                            let suppliers = r["Supplier"].split(",");
                            for(let s = 0 ; s < suppliers.length ; s++) {
                              let supplier = {
                                title: suppliers[s].trim(),
                              };
                              product.suppliers.push(supplier);
                            }
                          }
                          if(r["Vendor"] !== undefined && r["Vendor"] !== "") {
                            let vendors = r["Vendor"].split(",");
                            for(let v = 0 ; v < vendors.length ; v++) {
                              let vendor = {
                                title: vendors[v].trim(),
                              };
                              product.vendors.push(vendor);
                            }
                          }
                          cats[catIndex].products.push(product);
                        }
                      }

                      if(cats.length > 0) {
                        self.updateBulk(cats);
                      }
                    }
                    reader.readAsArrayBuffer(f);
                  })


                }
              }
            },
            get_header_row: function (sheet) {
              var headers = [], range = XLSX.utils.decode_range(sheet['!ref']);
              //range.s.r = 2;//XLSX.utils.decode_row("3");
              var C, R = range.s.r; /* start in the first row */
              for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
                var cell = sheet[XLSX.utils.encode_cell({c: C, r: R})] /* find the cell in the first row */
                var hdr = "UNKNOWN " + C; // <-- replace with your desired default
                if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
                headers.push(hdr);
              }
              return headers;
            },
            fixdata: function (data) {
              var o = "", l = 0, w = 10240;
              for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
              o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
              return o;
            },
            updateBulk: function(cats) {
              let self = this;

              // console.log(cats);
              // return;
              let counts = 0;
              for(let i = 0 ; i < cats.length ; i++) {
                counts += cats[i].products.length;
              }
              console.log("Item count " + counts);
              // return;
              updateProductBulk(cats)
              .then(function(data) {
                if(data.success == true) {
                  self.$data.categories = [];
                  self.getCategoryList();
                } else {
                  showDialog("Failed to update products " + data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })
            },
          openManual: function() {
            let url = "https://sites.google.com/boriumstudio.com/kokoro-erp-manual/%EC%83%81%ED%92%88%EA%B4%80%EB%A6%AC";
            window.open(url, '_blank');
          },
          downloadProductStockReport: function(product) {
            let self = this;
            const FileDownload = require('js-file-download');
            let fileName = 'Kokoro-' + product.title + '-full-stock.xlsx';
            getProductFullStockReport(product.id)
              .then(function(response) {
                FileDownload(response.data, fileName);
              })
              .catch(function(err) {
                console.log("report error " + err);
                if(err.response != undefined) {
                  console.log(err.response);
                }
              })
          },
          downloadCategoryStockReport: function(category) {
            let self = this;
            const FileDownload = require('js-file-download');
            let fileName = 'Kokoro-' + category.title + '-full-stock.xlsx';
            getCategoryProductsFullStockReport(category.id)
              .then(function(response) {
                FileDownload(response.data, fileName);
              })
              .catch(function(err) {
                console.log("report error " + err);
                if(err.response != undefined) {
                  console.log(err.response);
                }
              })
          },
          downloadProductsMigrationStockReport: function(cat) {
            let self = this;
            const FileDownload = require('js-file-download');
            let date = new Date();
            let fileName = 'Kokoro-migration-full-stock-' + date.getTime() + '.xlsx';
            getAllProductsMigrationFullStockReport(cat.id)
              .then(function(response) {
                FileDownload(response.data, fileName);
              })
              .catch(function(err) {
                console.log("report error " + err);
                if(err.response != undefined) {
                  console.log(err.response);
                }
              })
          },
          downloadProductMigrationStockReport: function(product) {
            let self = this;
            const FileDownload = require('js-file-download');
            let fileName = 'Kokoro-' + product.title + '-migration-full-stock.xlsx';
            getProductsMigrationFullStockReport(product.id)
              .then(function(response) {
                FileDownload(response.data, fileName);
              })
              .catch(function(err) {
                console.log("report error " + err);
                if(err.response != undefined) {
                  console.log(err.response);
                }
              })
          },
          openProductDataView: function(product) {
            this.$data.productDataView = {
              product: product
            }
          },

          onProductUpdateNotified: function(id) {
            // let self = this;
            console.log("Get updated product " + id)
            this.refreshProductItem(id);
            // getProductItemById(id)
            //   .then(function(data) {
            //     if(data.success == true) {
            //       for(let i = 0 ; i < self.$data.products.length ; i++) {
            //         if(self.$data.products[i].id == data.item.id) {
            //           self.$data.products.splice(i, 1, data.item);
            //           break;
            //         }
            //       }
            //       // if(self.$data.editProductItem != false && self.$data.editProductItem.id == data.item.id) {
            //       //   self.$data.editProductItem = data.item;
            //       // }
            //     } else {
            //       console.log()
            //     }
            //   })
            //   .catch(function(err) {
            //     console.log(err);
            //   })

          },
          closeProductDataView: function() {
            this.$data.productDataView = false;
          },
          recalculateEndingDate: function(item) {

            let self = this;
            calculateEndingStockProduct(item.id)
              .then(function(data) {
                if(data.success === true) {

                  for(let i = 0 ; i < self.$data.products.length ; i++) {
                    if(self.$data.products[i].id === data.item.id) {
                      self.$data.products.splice(i, 1, data.item);
                    }
                  }
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {

              })
          },
          numberOfDaysToEnd: function(item) {

            if(item.expectedEndDate === null) {
              return '';
            }
            if(item.expectedEndDate === '0000-00-00') {
              return '<span style="color:red; font-weight:bold">NA</span>';
            }
            let today = new Date();
            let endingDate = new Date(item.expectedEndDate);
            let diffTime = endingDate - today;
            let diffDays = Math.floor(diffTime / (60000*60*24));
            if(diffDays === 0) {
              return '<span style="color:red; font-weight:bold">Today</span>';
            } else if(diffDays === 0) {

              return '<span style="color:red; font-weight:bold">' + Math.abs(diffDays) + ' days past</span>';
            } else if(diffDays === 1) {

                return '<span style="color:red; font-weight:bold">Tomorrow</span>';
            } else if(diffDays <= 14) {
              return '<span style="color:#e7344c; font-weight:bold">In ' + Math.abs(diffDays) + ' days</span>';
            } else {
              return '<span>In ' + Math.abs(diffDays) + ' days</span>';
            }
            return '';
          }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css" scoped>
  .side-menu {
    position: absolute;
    left: 0;
    overflow-x: hidden;
    width:0;
    height: 100%;
    background: blue;
    color: white;
    transition: 0.5s;
    z-index: 1000;


  }
  .side-menu.show {
    width: 200px;
    padding-top:70px;
  }
  .category-container {
    background: gray;
    border-right: 1px solid #2c3e50;
  }
  .category-container li {
    background: white;
  }
  .category-container i {
    font-size:22px;
  }
  .list-group-item.category-selected {
    background: #006fb9;
    color:white;
  }
  .list-group {
    width:100%;
    background: inherit;

  }
  .list-group-item {
    background: inherit;
    cursor: pointer;
  }

  .product-item.category-selected {
    background: blue;
    color:white;
  }
  .list-group-item.category-selected > .selected-arrow {
    position: absolute;
    left: 100%;
    top:0;
    height: 100%;
    width: 30px;
    background-color:#006fb9;
    clip-path: polygon(0 0, 100% 50%, 0 100%);
  }

  /*.form-container {*/
  /*  position: absolute;*/
  /*  background: rgba(0,0,0,0.4);*/
  /*  top: 0;*/
  /*  left: 0;*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*  z-index: 998;*/
  /*}*/
  .form-inner-container {
    position: absolute;
    width: 80%;
    max-width: 700px;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: white;
    padding:50px;
    padding-bottom:70px;
    overflow-y: scroll;
  }
  .form-button-container {
    position: sticky;
    bottom:-70px;
    left: 0;
    width: 100%;
    padding:20px;
    background: white;
  }
  label.form-control {
    border:none;
    background: none;
  }
  .stock-in {
    border-left:5px solid blue;
  }
  .stock-out {
    border-left:5px solid red;
  }
  .stock-correction {
    border-left:5px solid green;
  }
  .price-input {
    max-width:100px;
    min-width:100px;
    -webkit-appearance: none;
    margin: 0;
  }


  .border-btn-select {
    background:blue;
    color:white;
  }
  .border-selector {
    border: 1px solid gray;
    padding:5px 10px 5px 10px;
    border-radius: 2px;
    cursor: pointer;
  }
  .border-btn-selected {
    background: blue;
    color: white;
  }
  .collapse-button {
    width: 40px;
    height: 40px;
    margin-top: -10px;
    margin-bottom: -10px;
    margin-right: -15px;
    background-image: url('/static/ic_collapse.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .rotate-if-collapsed {
    -webkit-transition: 0.3s ease-in-out;
    -moz-transition: 0.3s ease-in-out;
    -o-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
  }
  /**
  펼치기 아이콘으로 expand/collapse할 경우
   */
  [data-toggle="collapse"][aria-expanded="true"].rotate-if-collapsed {
    -webkit-transform: rotate(180deg);
    -moz-transform:    rotate(180deg);
    -ms-transform:     rotate(180deg);
    -o-transform:      rotate(180deg);
    transform:         rotate(180deg);
  }

  /**
  div안에 아이콘이 child로 들어가있고, div를 클릭하여 expand/collapse할 경우의 style
   */
  [data-toggle="collapse"][aria-expanded="true"] .rotate-if-collapsed {
    -webkit-transform: rotate(180deg);
    -moz-transform:    rotate(180deg);
    -ms-transform:     rotate(180deg);
    -o-transform:      rotate(180deg);
    transform:         rotate(180deg);
  }
  .low-stock-item {
    background:red;
    color: white;
  }
  .image-list-container {
    height: 200px;

    display: flex;
    white-space: nowrap;

    margin-bottom: 10px;
  }
  .image-list-container .image-item{

    height: 200px;
    width:200px;
    display: inline-block;
    margin-left: 10px;

  }
  .image-item {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;

    background-color: gray;
  }
  .image-list-container .image-control {
    height: 200px;
    width: 300px;
    margin-left: 10px;
    border-radius: 10px;

    border:1px solid gray;
  }
  .image-control progress {
    width: 90%;
    height: 30px;
    margin-top:30px;
  }
  .image-control input {
    width: 90%;
  }

  .top-left-icon {
    position: absolute;
    top: 10px;
    right:10px;
    color: red;
    background-color: white;
    padding:10px;
    box-shadow: 5px 5px 5px gray;
    border-radius: 50%;

  }
  .img-input-container {
    height: 250px;
    display: inline-block;
    margin-left: 10px;
  }
  .option-img-input-container {
    width: 100px;
    height: 100px;
  }
  .tag-container {
    /*width: 100%;*/
    /*padding:10px;*/
    /*text-align: left;*/
    display: inline-block;
    padding:10px;
    border: 1px solid #e4e4e4;

  }
  .tag-container > .selected-tag {
    height:30px;
    line-height: 30px;
    float: left;
    border-radius: 15px;
    background-color: #006fb9;
    color:white;
    padding-left: 20px;
    padding-right:20px;
    margin-right:10px;
  }
  .tag-container > .tag-item {
    height:30px;
    line-height: 30px;
    float: left;
    border-radius: 15px;
    color:black;
    padding-left: 20px;
    padding-right:20px;
    margin-right:10px;
    background-color: #E8E8E8;
  }
  .tag-container > span {
    padding:3px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
    border:1px solid #CCCCCC;
    margin-right:10px;
  }
  .sold-out {
    background: red;
    color: white;
  }
  .stock-view-quantity-title {
    text-align: center;
    line-height: 40px;
    font-weight: bold;
  }
  .stock-view-quantity {
    text-align: center;
    font-size: 30px;
    line-height: 50px;
    font-weight: bold;
  }
  .stock-view-quantity.weight {
    font-size: 20px;
  }
  .green-btn {
    background: #45c143;
    color: white;
  }
  .red-btn {
    background: #f03232;
    color: white;
  }

  .inventory-table {
  }
  .inventory-table th, .inventory-table td  {
    padding: 5px 10px;
    text-align: center;
    font-size: 1rem;
  }
  .inventory-table th {
    border: 1px solid #ddd;

    padding-top: 12px;
    padding-bottom: 12px;
    background-color: #04AA6D;
    color: white;
  }
  .inventory-table tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  .inventory-table tr:hover {
    background-color: #ddd;
  }


  button.tab {
    background-color: inherit;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding-right: 20px;
    padding-left: 20px;
    height: 50px;
    line-height: 50px;
    transition: 0.3s;
    font-size: 1.5rem;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    color: #888;
    background-color: #eee;
  }
  button.tab:hover {
    background-color: #ddd;
  }
  button.tab.active {
    background-color: #ccc;
    color:black;
  }

  .form-row {
    text-align: left;
  }
  .form-row > div {
    margin-top: 15px;
  }

  .large-font .form-control {
    font-size: 15px;
  }
  .bold {
    font-weight: bold;
  }

  .warning-input {
    background: #e8344c;
    color: white;
    font-weight: bold;
  }

  .attention-required {
    color: #e8344c;
    font-weight: bold;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;

  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .enabled .slider {
    background-color: #2196F3;
  }

  .enabled .slider {
    box-shadow: 0 0 1px #2196F3;
  }

  .enabled .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .product-title-bg-0 {
    background: #A7C7E7;
    color: black;
  }
  .product-title-bg-1 {
    background: #B2D8B2;
    color: black;
  }
  .product-title-bg-2 {
    background: #F2E2A7;
    color: black;
  }
  .product-title-bg-3 {
    background: #D3B2E7;
    color: black;
  }
  .product-title-bg-4 {
    background: #E0E0E0;
    color: black;
  }
  .product-title-bg-5 {
    background: #D89090;
    color: black;
  }
  .product-bg-selector {
    border: 2px solid black;
  }
  .product-bg-selector.unselected {
    border: 20px solid white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Products.vue